import { Directive, ChangeDetectorRef, Input, NgModule } from '@angular/core';
import { FaIconComponent, FaIconLibrary, FaConfig, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { config, icon, toHtml } from '@fortawesome/fontawesome-svg-core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fortawesome/angular-fontawesome';
const facDownload = {
    prefix: 'fac',
    iconName: 'facDownload',
    icon: [
        20,
        20,
        [],
        '',
        'M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facUpload = {
    prefix: 'fac',
    iconName: 'facUpload',
    icon: [
        20,
        20,
        [],
        '',
        'M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M15 6L10 1M10 1L5 6M10 1V13'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facEdit = {
    prefix: 'fac',
    iconName: 'facEdit',
    icon: [
        16,
        16,
        [],
        '',
        'M11.3333 2.00004C11.5083 1.82494 11.7162 1.68605 11.945 1.59129C12.1738 1.49653 12.419 1.44775 12.6666 1.44775C12.9142 1.44775 13.1594 1.49653 13.3882 1.59129C13.617 1.68605 13.8248 1.82494 13.9999 2.00004C14.175 2.17513 14.3139 2.383 14.4087 2.61178C14.5034 2.84055 14.5522 3.08575 14.5522 3.33337C14.5522 3.58099 14.5034 3.82619 14.4087 4.05497C14.3139 4.28374 14.175 4.49161 13.9999 4.66671L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2.00004Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facTrash = {
    prefix: 'fac',
    iconName: 'facTrash',
    icon: [
        24,
        24,
        [],
        '',
        'M3 6H5H21 M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z M10 11V17 M14 11V17'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facUndo = {
    prefix: 'fac',
    iconName: 'facUndo',
    icon: [
        18,
        18,
        [],
        '',
        'M6 7L1 12M1 12L6 17M1 12H13C14.0609 12 15.0783 11.5786 15.8284 10.8284C16.5786 10.0783 17 9.06087 17 8V1'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facRedo = {
    prefix: 'fac',
    iconName: 'facRedo',
    icon: [
        18,
        18,
        [],
        '',
        'M12 7L17 12M17 12L12 17M17 12H5C3.93913 12 2.92172 11.5786 2.17157 10.8284C1.42143 10.0783 1 9.06087 1 8V1'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facAddUsers = {
    prefix: 'fac',
    iconName: 'addUser',
    icon: [
        20,
        14,
        [],
        '',
        'M17 5V9 M19 7H15 M9.91658 12.25V11.0833C9.91658 10.4645 9.67075 9.871 9.23317 9.43342C8.79558 8.99583 8.20209 8.75 7.58325 8.75H2.91659C2.29775 8.75 1.70425 8.99583 1.26667 9.43342C0.829085 9.871 0.583252 10.4645 0.583252 11.0833V12.25 M5.25008 6.41667C6.53875 6.41667 7.58342 5.372 7.58342 4.08333C7.58342 2.79467 6.53875 1.75 5.25008 1.75C3.96142 1.75 2.91675 2.79467 2.91675 4.08333C2.91675 5.372 3.96142 6.41667 5.25008 6.41667Z M13.4167 12.25V11.0833C13.4164 10.5663 13.2443 10.0641 12.9275 9.65552C12.6108 9.24692 12.1673 8.95508 11.6667 8.82584 M9.33325 1.82584C9.83516 1.95435 10.28 2.24625 10.5977 2.65552C10.9154 3.06479 11.0878 3.56815 11.0878 4.08625C11.0878 4.60435 10.9154 5.10772 10.5977 5.51699C10.28 5.92626 9.83516 6.21816 9.33325 6.34667'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor'
    }
};
const facOrganization = {
    prefix: 'fac',
    iconName: 'facOrganization',
    icon: [
        16,
        16,
        [],
        '',
        'M4.5 3.5H0.5V15.5H4.5M4.5 3.5V15.5M4.5 3.5V0.5H11.5V3.5M4.5 15.5H11.5M11.5 15.5H15.5V3.5H11.5M11.5 15.5V3.5M6 3.5H10 M6 6.5H10 M6 9.5H10M6.5 15V12.5H9.5V15'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor'
    }
};
const facLink = {
    prefix: 'fac',
    iconName: 'facLink',
    icon: [
        14,
        14,
        [],
        '',
        'M7.9473 6.02151C8.20662 6.27559 8.41263 6.57886 8.55327 6.91356C8.69392 7.24826 8.76636 7.60765 8.76636 7.9707C8.76636 8.33375 8.69392 8.69314 8.55327 9.02784C8.41263 9.36254 8.20662 9.66581 7.9473 9.91989L5.71743 12.1108C5.46335 12.3701 5.16008 12.5761 4.82538 12.7167C4.49069 12.8574 4.13129 12.9298 3.76824 12.9298C3.4052 12.9298 3.0458 12.8574 2.7111 12.7167C2.37641 12.5761 2.07314 12.3701 1.81906 12.1108C1.55974 11.8567 1.35372 11.5534 1.21308 11.2187C1.07244 10.884 1 10.5246 1 10.1616C1 9.79854 1.07244 9.43914 1.21308 9.10445C1.35372 8.76975 1.55974 8.46648 1.81906 8.2124L2.48958 7.54188 M6.09169 7.90832C5.83237 7.65424 5.62635 7.35097 5.48571 7.01627C5.34507 6.68157 5.27263 6.32218 5.27263 5.95913C5.27263 5.59608 5.34507 5.23669 5.48571 4.90199C5.62635 4.56729 5.83237 4.26402 6.09169 4.00994L8.28257 1.81906C8.53665 1.55974 8.83992 1.35372 9.17462 1.21308C9.50932 1.07244 9.86871 1 10.2318 1C10.5948 1 10.9542 1.07244 11.2889 1.21308C11.6236 1.35372 11.9269 1.55974 12.1809 1.81906C12.4403 2.07314 12.6463 2.37641 12.7869 2.7111C12.9276 3.0458 13 3.4052 13 3.76824C13 4.13129 12.9276 4.49069 12.7869 4.82538C12.6463 5.16008 12.4403 5.46335 12.1809 5.71743L11.5104 6.38795'
    ],
    customStyles: {
        fill: 'none',
        stroke: '#747474'
    }
};
const facClone = {
    prefix: 'fac',
    iconName: 'facClone',
    icon: [
        24,
        24,
        [],
        '',
        'M 15.00,5.00 ' +
            'C 15.00,5.00 15.00,4.00 15.00,4.00 ' +
            '15.00,3.47 14.79,2.96 14.41,2.59 ' +
            '14.04,2.21 13.53,2.00 13.00,2.00 ' +
            '13.00,2.00 4.00,2.00 4.00,2.00 ' +
            '3.47,2.00 2.96,2.21 2.59,2.59 ' +
            '2.21,2.96 2.00,3.47 2.00,4.00 ' +
            '2.00,4.00 2.00,13.00 2.00,13.00 ' +
            '2.00,13.53 2.21,14.04 2.59,14.41 ' +
            '2.96,14.79 3.47,15.00 4.00,15.00 ' +
            '4.00,15.00 5.00,15.00 5.00,15.00M 22.00,11.00 ' +
            'C 22.00,11.00 22.00,20.00 22.00,20.00 ' +
            '22.00,21.10 21.10,22.00 20.00,22.00 ' +
            '20.00,22.00 11.00,22.00 11.00,22.00 ' +
            '9.90,22.00 9.00,21.10 9.00,20.00 ' +
            '9.00,20.00 9.00,11.00 9.00,11.00 ' +
            '9.00,9.90 9.90,9.00 11.00,9.00 ' +
            '11.00,9.00 20.00,9.00 20.00,9.00 ' +
            '21.10,9.00 22.00,9.90 22.00,11.00 Z'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor'
    }
};
const facPlusRegular = {
    prefix: 'fac',
    iconName: 'plus',
    icon: [24, 24, [], '', 'M12 5V19 M5 12H19'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facOpenFolderO = {
    prefix: 'fac',
    iconName: 'facOpenFolderO',
    icon: [
        24,
        24,
        [],
        '',
        'M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facKeyBold = {
    prefix: 'fac',
    iconName: 'key',
    icon: [
        16,
        16,
        [],
        '',
        'M13.5 6.28127C13.5 8.3696 11.8071 10.0625 9.71875 10.0625C9.4777 10.0625 9.24201 10.0397 9.01348 9.99656L8.4976 10.5769C8.44922 10.6314 8.38987 10.6749 8.32344 10.7048C8.25702 10.7346 8.18503 10.75 8.11221 10.75H7.3125V11.6094C7.3125 11.8942 7.08165 12.125 6.79688 12.125H5.9375V12.9844C5.9375 13.2692 5.70665 13.5 5.42188 13.5H3.01562C2.73085 13.5 2.5 13.2692 2.5 12.9844V11.3073C2.5 11.1706 2.55433 11.0394 2.65101 10.9427L6.12723 7.4665C6.00427 7.09366 5.9375 6.69528 5.9375 6.28125C5.9375 4.19293 7.6304 2.50002 9.71873 2.5C11.8132 2.49998 13.5 4.18676 13.5 6.28127ZM9.71875 5.25C9.71875 5.81955 10.1804 6.28125 10.75 6.28125C11.3196 6.28125 11.7812 5.81955 11.7812 5.25C11.7812 4.68045 11.3196 4.21875 10.75 4.21875C10.1804 4.21875 9.71875 4.68045 9.71875 5.25Z'
    ]
};
const facfilledExclamatory = {
    prefix: 'fac',
    iconName: 'facfilledExclamatory',
    icon: [
        14,
        14,
        [],
        '',
        'M11.8125 6.5C11.8125 3.3125 9.1875 0.6875 6 0.6875C2.78906 0.6875 0.1875 3.3125 0.1875 6.5C0.1875 9.71094 2.78906 12.3125 6 12.3125C9.1875 12.3125 11.8125 9.71094 11.8125 6.5ZM6 7.67188C6.58594 7.67188 7.07812 8.16406 7.07812 8.75C7.07812 9.35938 6.58594 9.82812 6 9.82812C5.39062 9.82812 4.92188 9.35938 4.92188 8.75C4.92188 8.16406 5.39062 7.67188 6 7.67188ZM4.96875 3.80469C4.94531 3.64062 5.08594 3.5 5.25 3.5H6.72656C6.89062 3.5 7.03125 3.64062 7.00781 3.80469L6.84375 6.99219C6.82031 7.15625 6.70312 7.25 6.5625 7.25H5.41406C5.27344 7.25 5.15625 7.15625 5.13281 6.99219L4.96875 3.80469Z'
    ],
    customStyles: {
        fill: '#F2994A',
        stroke: 'none'
    }
};
const facSitemapO = {
    prefix: 'fac',
    iconName: 'facSitemapO',
    icon: [
        14,
        14,
        [],
        '',
        'M8.05 1.72738V3.77262L8.03559 3.78559L8.02262 3.8H5.95704C5.95515 3.79851 5.9528 3.79655 5.95 3.79403V1.70597C5.9528 1.70345 5.95515 1.70149 5.95704 1.7H8.02262L8.03559 1.71441L8.05 1.72738ZM5.44688 1.21875C5.59271 1.07292 5.76042 1 5.95 1H8.05C8.23958 1 8.4 1.07292 8.53125 1.21875C8.67708 1.35 8.75 1.51042 8.75 1.7V3.8C8.75 3.98958 8.67708 4.15 8.53125 4.28125C8.4 4.42708 8.23958 4.5 8.05 4.5H5.95C5.76042 4.5 5.59271 4.42708 5.44688 4.28125C5.31563 4.15 5.25 3.98958 5.25 3.8V1.7C5.25 1.51042 5.31563 1.35 5.44688 1.21875Z M2.8 9.72738V11.7726L2.78559 11.7856L2.77262 11.8H0.707043C0.705153 11.7985 0.702798 11.7966 0.7 11.794V9.70597C0.702798 9.70345 0.705153 9.70149 0.707043 9.7H2.77262L2.78559 9.71441L2.8 9.72738ZM8.05 9.72738V11.7726L8.03559 11.7856L8.02262 11.8H5.95704C5.95515 11.7985 5.9528 11.7966 5.95 11.794V9.70597C5.9528 9.70345 5.95515 9.70149 5.95704 9.7H8.02262L8.03559 9.71441L8.05 9.72738ZM13.3 9.72738V11.7726L13.2856 11.7856L13.2726 11.8H11.207C11.2052 11.7985 11.2028 11.7966 11.2 11.794V9.70597C11.2028 9.70345 11.2052 9.70149 11.207 9.7H13.2726L13.2856 9.71441L13.3 9.72738ZM3.28125 12.2812C3.42708 12.15 3.5 11.9896 3.5 11.8V9.7C3.5 9.51042 3.42708 9.35 3.28125 9.21875C3.15 9.07292 2.98958 9 2.8 9H0.7C0.510417 9 0.342708 9.07292 0.196875 9.21875C0.065625 9.35 0 9.51042 0 9.7V11.8C0 11.9896 0.065625 12.15 0.196875 12.2812C0.342708 12.4271 0.510417 12.5 0.7 12.5H2.8C2.98958 12.5 3.15 12.4271 3.28125 12.2812ZM13.7812 9.21875C13.65 9.07292 13.4896 9 13.3 9H11.2C11.0104 9 10.8427 9.07292 10.6969 9.21875C10.5656 9.35 10.5 9.51042 10.5 9.7V11.8C10.5 11.9896 10.5656 12.15 10.6969 12.2812C10.8427 12.4271 11.0104 12.5 11.2 12.5H13.3C13.4896 12.5 13.65 12.4271 13.7812 12.2812C13.9271 12.15 14 11.9896 14 11.8V9.7C14 9.51042 13.9271 9.35 13.7812 9.21875ZM8.53125 12.2812C8.67708 12.15 8.75 11.9896 8.75 11.8V9.7C8.75 9.51042 8.67708 9.35 8.53125 9.21875C8.4 9.07292 8.23958 9 8.05 9H5.95C5.76042 9 5.59271 9.07292 5.44688 9.21875C5.31563 9.35 5.25 9.51042 5.25 9.7V11.8C5.25 11.9896 5.31563 12.15 5.44688 12.2812C5.59271 12.4271 5.76042 12.5 5.95 12.5H8.05C8.23958 12.5 8.4 12.4271 8.53125 12.2812Z M6.75 9.5V4.5H7.25V9.5H6.75Z M1.5498 7.5C1.5498 7.08579 1.88559 6.75 2.2998 6.75H11.7C12.1142 6.75 12.45 7.08579 12.45 7.5V9.2H11.95V7.5C11.95 7.36193 11.8381 7.25 11.7 7.25H2.2998C2.16173 7.25 2.0498 7.36193 2.0498 7.5V9.2H1.5498V7.5Z'
    ]
};
const facOpenLog = {
    prefix: 'fac',
    iconName: 'facOpenLog',
    icon: [
        14,
        13,
        [],
        '',
        'M1.00004 0.000403871H12L12.0681 0.000199102C12.3494 -0.00107634 12.5974 -0.00220105 12.8 0.200404C13.0026 0.403009 13.0015 0.651058 13.0002 0.932351L13 1.0004V3.0004H12V1.0004H1.00004V12.0004H12V10.0004H13V12.0004L13.0002 12.0685C13.0015 12.3497 13.0026 12.5978 12.8 12.8004C12.5974 13.003 12.3494 13.0019 12.0681 13.0006L12 13.0004H1.00004L0.931987 13.0006C0.650694 13.0019 0.402645 13.003 0.20004 12.8004C-0.00256509 12.5978 -0.00144037 12.3497 -0.000164911 12.0685L3.98611e-05 12.0004V1.01183L-0.000165301 0.94364C-0.00144562 0.660881 -0.0026132 0.403019 0.200002 0.200404C0.402607 -0.00220116 0.650689 -0.00107634 0.931987 0.000199105L1.00004 0.000403871ZM2.00004 8.0004H5V7.0004H2.00004V8.0004ZM2.00004 6.0004H5V5.0004H2.00004V6.0004ZM2.00004 10.0004H5.00004V9.0004H2.00004V10.0004ZM2 3.0004H5V4.0004H2V3.0004ZM10 8.0004V10.0004L14 6.5004L10 3.0004V5.0004H6V8.0004H10ZM11 5.20417L12.4814 6.5004L11 7.79664V7.0004H7V6.0004H11V5.20417'
    ]
};
const facClock = {
    prefix: 'fac',
    iconName: 'clock1',
    icon: [
        10,
        10,
        [],
        '',
        'M4.48477 0.748793V0C3.50764 0.095255 2.57561 0.471262 1.81395 1.10295L2.34073 1.64843C2.94441 1.16825 3.68022 0.847232 4.48477 0.748793ZM2.32889 8.37015C2.93477 8.85556 3.67495 9.18015 4.48477 9.27924V9.99676C3.50263 9.89148 2.5706 9.49542 1.81395 8.86373L2.32889 8.37015ZM0.741934 5.48468C0.830125 6.29464 1.14328 7.03699 1.61757 7.64788L1.11242 8.15683C0.49107 7.39479 0.105229 6.46731 0.00501091 5.48468H0.741934ZM1.64389 2.34659C1.16702 2.94843 0.847904 3.68108 0.74906 4.482H0C0.100218 3.49937 0.476037 2.57188 1.10741 1.80984L1.64389 2.34659ZM5.4882 0.0100502V0C7.85915 0.236181 9.74889 2.1206 9.97445 4.50754C10.2501 7.27136 8.24512 9.72362 5.4882 10V9.30315C7.63571 9.06516 9.30604 7.23993 9.30604 5.0236C9.30604 2.80727 7.63571 0.982044 5.4882 0.744053V0.0100502ZM5.2382 5.13551V2.49731H4.48632V5.51239L7.11792 7.0953L7.49386 6.47721L5.2382 5.13551Z'
    ]
};
const clock = {
    prefix: 'fac',
    iconName: 'clock',
    icon: [
        14,
        14,
        [],
        '',
        'M3.1875 2.99609C4.51823 1.66536 6.1224 1 8 1C9.8776 1 11.4727 1.66536 12.7852 2.99609C14.1159 4.30859 14.7812 5.90365 14.7812 7.78125C14.7812 9.65885 14.1159 11.263 12.7852 12.5938C11.4727 13.9062 9.8776 14.5625 8 14.5625C6.1224 14.5625 4.51823 13.9062 3.1875 12.5938C1.875 11.263 1.21875 9.65885 1.21875 7.78125C1.21875 5.90365 1.875 4.30859 3.1875 2.99609ZM4.11719 11.6641C5.19271 12.7214 6.48698 13.25 8 13.25C9.51302 13.25 10.7982 12.7214 11.8555 11.6641C12.931 10.5885 13.4688 9.29427 13.4688 7.78125C13.4688 6.26823 12.931 4.98307 11.8555 3.92578C10.7982 2.85026 9.51302 2.3125 8 2.3125C6.48698 2.3125 5.19271 2.85026 4.11719 3.92578C3.0599 4.98307 2.53125 6.26823 2.53125 7.78125C2.53125 9.29427 3.0599 10.5885 4.11719 11.6641ZM9.69531 10.4062L7.37109 8.71094C7.27995 8.63802 7.23438 8.54688 7.23438 8.4375V3.95312C7.23438 3.73438 7.34375 3.625 7.5625 3.625H8.4375C8.65625 3.625 8.76562 3.73438 8.76562 3.95312V7.83594L10.5977 9.14844C10.7617 9.27604 10.7799 9.43099 10.6523 9.61328L10.1602 10.3242C10.0326 10.5065 9.8776 10.5339 9.69531 10.4062Z'
    ]
};
const facArrowDownRegular = {
    prefix: 'fac',
    iconName: 'facArrowDownRegular',
    icon: [16, 16, [], '', 'M8 1V15M8 15L15 8M8 15L1 8'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowUpRegular = {
    prefix: 'fac',
    iconName: 'facArrowUpRegular',
    icon: [16, 16, [], '', 'M8 15V1M8 1L1 8M8 1L15 8'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowLeftRegular = {
    prefix: 'fac',
    iconName: 'facArrowLeftRegular',
    icon: [24, 24, [], '', 'M19 12H5 M12 19L5 12L12 5'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowRightRegular = {
    prefix: 'fac',
    iconName: 'facArrowRightRegular',
    icon: [24, 24, [], '', 'M5 12H19 M12 5L19 12L12 19'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facAddNewPipeline = {
    prefix: 'fac',
    iconName: 'facAddNewPipeline',
    icon: [
        24,
        24,
        [],
        '',
        'M14 15L14 9 M7 15L7 14C7 13.4696 7.21071 12.9609 7.58579 12.5858C7.96086 12.2107 8.46957 12 9 12L19 12C19.5304 12 20.0391 12.2107 20.4142 12.5858C20.7893 12.9609 21 13.4696 21 14L21 15 M16 4.5H12V8.5H16V4.5Z M16 15.5H12V19.5H16V15.5Z M9 15.5H5V19.5H9V15.5Z M23 15.5H19V19.5H23V15.5Z M4 10V4 M1 7H7'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facDelete = {
    prefix: 'fac',
    iconName: 'facDelete',
    icon: [
        14,
        14,
        [],
        '',
        'M9.8182 4.96959L7.99993 6.78786L6.18166 4.96959C5.967 4.75493 5.58819 4.75493 5.37353 4.96959L4.96947 5.37365C4.74219 5.60093 4.75482 5.96711 4.96947 6.18177L6.78775 8.00004L4.96947 9.81832C4.74219 10.0456 4.75482 10.4118 4.96947 10.6264L5.37353 11.0305C5.60082 11.2578 5.95437 11.2578 6.18166 11.0305L7.99993 9.21223L9.8182 11.0305C10.0455 11.2578 10.399 11.2578 10.6263 11.0305L11.0304 10.6264C11.245 10.4118 11.2577 10.0456 11.0304 9.81832L9.21211 8.00004L11.0304 6.18177C11.245 5.96711 11.2577 5.60093 11.0304 5.37365L10.6263 4.96959C10.4117 4.75493 10.0329 4.75493 9.8182 4.96959Z'
    ]
};
const facExternalLink = {
    prefix: 'fac',
    iconName: 'facExternalLink',
    icon: [
        17,
        17,
        [],
        '',
        'M14 12.1333V14C14 14.5304 13.7893 15.0391 13.4142 15.4142C13.0391 15.7893 12.5304 16 12 16L3 16C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14L1 5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H4.86667M7 10L16 1M16 1H9M16 1L16 8'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facCog = {
    prefix: 'fac',
    iconName: 'cog',
    icon: [
        24,
        24,
        [],
        '',
        'M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const cogsIcon = {
    prefix: 'fac',
    iconName: 'cogs',
    icon: [
        16,
        16,
        [],
        '',
        'M7.50098 8C7.50098 9.10156 6.60254 10 5.50098 10C4.39941 10 3.50098 9.10156 3.50098 8C3.50098 6.89844 4.39941 6 5.50098 6C6.60254 6 7.50098 6.89844 7.50098 8ZM13.501 12C13.501 12.5469 13.0557 13 12.501 13C11.9541 13 11.501 12.5547 11.501 12C11.501 11.4531 11.9541 11 12.501 11C13.0479 11 13.501 11.4531 13.501 12ZM13.501 4C13.501 4.54688 13.0557 5 12.501 5C11.9541 5 11.501 4.55469 11.501 4C11.501 3.45312 11.9541 3 12.501 3C13.0479 3 13.501 3.45312 13.501 4ZM10.501 7.28906C10.501 7.17969 10.4229 7.07813 10.3135 7.05469L9.12598 6.875C9.05566 6.65625 8.96191 6.44531 8.86035 6.23438C9.0791 5.92969 9.31348 5.64844 9.54004 5.34375C9.57129 5.29688 9.59473 5.25 9.59473 5.19531C9.59473 4.97656 8.67285 4.13281 8.46973 3.94531C8.42285 3.90625 8.36816 3.88281 8.30566 3.88281C8.25098 3.88281 8.19629 3.89844 8.14941 3.9375L7.22754 4.63281C7.04004 4.53906 6.84473 4.45313 6.6416 4.39063L6.46191 3.19531C6.44629 3.08594 6.33691 3 6.22754 3H4.77441C4.66504 3 4.57129 3.07813 4.54004 3.1875C4.43848 3.57031 4.39941 4 4.36035 4.39063C4.14941 4.46094 3.9541 4.53906 3.75879 4.64063L2.86035 3.9375C2.81348 3.90625 2.75879 3.88281 2.69629 3.88281C2.46973 3.88281 1.59473 4.82813 1.43848 5.03906C1.39941 5.08594 1.38379 5.14062 1.38379 5.19531C1.38379 5.25 1.40723 5.30469 1.43848 5.35156C1.68848 5.64844 1.92285 5.9375 2.1416 6.25C2.04004 6.44531 1.9541 6.64062 1.8916 6.84375L0.680664 7.03125C0.579102 7.04688 0.500977 7.16406 0.500977 7.26563V8.71094C0.500977 8.82031 0.579102 8.92188 0.688477 8.9375L1.87598 9.125C1.94629 9.34375 2.04004 9.55469 2.14941 9.76563C1.92285 10.0703 1.68848 10.3594 1.46191 10.6563C1.43066 10.7031 1.40723 10.75 1.40723 10.8047C1.40723 11.0313 2.3291 11.8672 2.53223 12.0547C2.5791 12.0938 2.63379 12.1172 2.69629 12.1172C2.75098 12.1172 2.81348 12.1016 2.85254 12.0625L3.77441 11.3672C3.96191 11.4609 4.15723 11.5469 4.36035 11.6094L4.54004 12.8047C4.55566 12.9141 4.66504 13 4.77441 13H6.22754C6.33691 13 6.43066 12.9219 6.46191 12.8125C6.56348 12.4297 6.60254 12 6.6416 11.6016C6.85254 11.5391 7.04785 11.4609 7.24316 11.3594L8.1416 12.0625C8.18848 12.0938 8.24316 12.1172 8.30566 12.1172C8.53223 12.1172 9.40723 11.1641 9.56348 10.9531C9.60254 10.9141 9.61816 10.8594 9.61816 10.8047C9.61816 10.7422 9.59473 10.6953 9.56348 10.6484C9.31348 10.3516 9.0791 10.0625 8.86035 9.75C8.96191 9.55469 9.04785 9.35938 9.11035 9.15625L10.3213 8.96875C10.4229 8.95313 10.501 8.83594 10.501 8.73438V7.28906ZM15.501 11.4531C15.501 11.3359 14.4932 11.2266 14.3369 11.2109C14.2744 11.0703 14.1963 10.9297 14.1025 10.8047C14.1729 10.6484 14.501 9.86719 14.501 9.72656C14.501 9.71094 14.4932 9.6875 14.4697 9.67188C14.376 9.61719 13.54 9.125 13.501 9.125L13.4541 9.14063C13.1885 9.40625 12.9541 9.71094 12.7354 10.0156C12.6572 10.0078 12.5791 10 12.501 10C12.4229 10 12.3447 10.0078 12.2666 10.0156C12.1885 9.89844 11.6025 9.125 11.501 9.125C11.4619 9.125 10.626 9.625 10.5322 9.67188C10.5088 9.6875 10.501 9.71094 10.501 9.72656C10.501 9.85938 10.8291 10.6484 10.8994 10.8047C10.8057 10.9297 10.7275 11.0703 10.665 11.2109C10.5088 11.2266 9.50098 11.3359 9.50098 11.4531V12.5469C9.50098 12.6641 10.5088 12.7734 10.665 12.7891C10.7275 12.9375 10.8057 13.0703 10.8994 13.1953C10.8291 13.3516 10.501 14.1406 10.501 14.2734C10.501 14.2891 10.5088 14.3125 10.5322 14.3281C10.626 14.3828 11.4619 14.8828 11.501 14.8828C11.6025 14.8828 12.1885 14.1016 12.2666 13.9844C12.3447 13.9922 12.4229 14 12.501 14C12.5791 14 12.6572 13.9922 12.7354 13.9844C12.8135 14.1016 13.3994 14.8828 13.501 14.8828C13.54 14.8828 14.376 14.3828 14.4697 14.3281C14.4932 14.3125 14.501 14.2969 14.501 14.2734C14.501 14.1328 14.1729 13.3516 14.1025 13.1953C14.1963 13.0703 14.2744 12.9375 14.3369 12.7891C14.4932 12.7734 15.501 12.6641 15.501 12.5469V11.4531ZM15.501 3.45312C15.501 3.33594 14.4932 3.22656 14.3369 3.21094C14.2744 3.07031 14.1963 2.92969 14.1025 2.80469C14.1729 2.64844 14.501 1.86719 14.501 1.72656C14.501 1.71094 14.4932 1.6875 14.4697 1.67188C14.376 1.61719 13.54 1.125 13.501 1.125L13.4541 1.14063C13.1885 1.40625 12.9541 1.71094 12.7354 2.01563C12.6572 2.00781 12.5791 2 12.501 2C12.4229 2 12.3447 2.00781 12.2666 2.01563C12.1885 1.89844 11.6025 1.125 11.501 1.125C11.4619 1.125 10.626 1.625 10.5322 1.67188C10.5088 1.6875 10.501 1.71094 10.501 1.72656C10.501 1.85938 10.8291 2.64844 10.8994 2.80469C10.8057 2.92969 10.7275 3.07031 10.665 3.21094C10.5088 3.22656 9.50098 3.33594 9.50098 3.45312V4.54687C9.50098 4.66406 10.5088 4.77344 10.665 4.78906C10.7275 4.9375 10.8057 5.07031 10.8994 5.19531C10.8291 5.35156 10.501 6.14063 10.501 6.27344C10.501 6.28906 10.5088 6.3125 10.5322 6.32812C10.626 6.38281 11.4619 6.88281 11.501 6.88281C11.6025 6.88281 12.1885 6.10156 12.2666 5.98438C12.3447 5.99219 12.4229 6 12.501 6C12.5791 6 12.6572 5.99219 12.7354 5.98438C12.8135 6.10156 13.3994 6.88281 13.501 6.88281C13.54 6.88281 14.376 6.38281 14.4697 6.32812C14.4932 6.3125 14.501 6.29688 14.501 6.27344C14.501 6.13281 14.1729 5.35156 14.1025 5.19531C14.1963 5.07031 14.2744 4.9375 14.3369 4.78906C14.4932 4.77344 15.501 4.66406 15.501 4.54687V3.45312Z'
    ],
    customStyles: {
        fill: 'currentColor'
    }
};
const starIcon = {
    prefix: 'fac',
    iconName: 'star',
    icon: [
        22,
        21,
        [],
        '',
        'M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const grid2HorizontalIcon = {
    prefix: 'fac',
    iconName: 'grid2Horizontal',
    icon: [20, 20, [], '', 'M19 1H1V8H19V1Z M19 12H1V19H19V12Z'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const gridIcon = {
    prefix: 'fac',
    iconName: 'grid',
    icon: [
        20,
        20,
        [],
        '',
        'M8 1H1V8H8V1Z M19 1H12V8H19V1Z M19 12H12V19H19V12Z M8 12H1V19H8V12Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facGear = {
    prefix: 'fac',
    iconName: 'gear',
    icon: [
        12,
        12,
        [],
        '',
        'M8 6C8 7.10156 7.10156 8 6 8C4.89844 8 4 7.10156 4 6C4 4.89844 4.89844 4 6 4C7.10156 4 8 4.89844 8 6ZM12 5.14844C12 5.01563 11.9062 4.89062 11.7734 4.86719L10.3438 4.64844C10.2656 4.39063 10.1562 4.13281 10.0234 3.88281C10.2891 3.51563 10.5781 3.17188 10.8438 2.8125C10.8828 2.75781 10.9062 2.70312 10.9062 2.63281C10.9062 2.57031 10.8906 2.50781 10.8516 2.46094C10.5234 2 9.97656 1.51563 9.5625 1.13281C9.50781 1.08594 9.4375 1.05469 9.36719 1.05469C9.29688 1.05469 9.22656 1.07813 9.17969 1.125L8.07031 1.96094C7.84375 1.84375 7.60938 1.75 7.36719 1.67187L7.14844 0.234375C7.13281 0.101563 7.00781 0 6.86719 0H5.13281C4.99219 0 4.88281 0.0937505 4.85156 0.21875C4.72656 0.6875 4.67969 1.19531 4.625 1.67187C4.38281 1.75 4.14062 1.85156 3.91406 1.96875L2.83594 1.13281C2.77344 1.08594 2.70312 1.05469 2.63281 1.05469C2.36719 1.05469 1.3125 2.19531 1.125 2.45312C1.08594 2.50781 1.05469 2.5625 1.05469 2.63281C1.05469 2.70312 1.08594 2.76562 1.13281 2.82031C1.42188 3.17187 1.70312 3.52344 1.96875 3.89844C1.84375 4.13281 1.74219 4.36719 1.66406 4.61719L0.210938 4.83594C0.09375 4.85938 0 5 0 5.11719V6.85156C0 6.98438 0.09375 7.10938 0.226562 7.13281L1.65625 7.34375C1.73438 7.60938 1.84375 7.86719 1.97656 8.11719C1.71094 8.48438 1.42188 8.82812 1.15625 9.1875C1.11719 9.24219 1.09375 9.29688 1.09375 9.36719C1.09375 9.42969 1.10938 9.49219 1.14844 9.54688C1.47656 10 2.02344 10.4844 2.4375 10.8594C2.49219 10.9141 2.5625 10.9453 2.63281 10.9453C2.70312 10.9453 2.77344 10.9219 2.82812 10.875L3.92969 10.0391C4.15625 10.1562 4.39063 10.25 4.63281 10.3281L4.85156 11.7656C4.86719 11.8984 4.99219 12 5.13281 12H6.86719C7.00781 12 7.11719 11.9062 7.14844 11.7812C7.27344 11.3125 7.32031 10.8047 7.375 10.3281C7.61719 10.25 7.85938 10.1484 8.08594 10.0312L9.16406 10.875C9.22656 10.9141 9.29688 10.9453 9.36719 10.9453C9.63281 10.9453 10.6875 9.79688 10.875 9.54688C10.9219 9.49219 10.9453 9.4375 10.9453 9.36719C10.9453 9.29688 10.9141 9.22656 10.8672 9.17188C10.5781 8.82031 10.2969 8.47656 10.0312 8.09375C10.1562 7.86719 10.25 7.63281 10.3359 7.38281L11.7812 7.16406C11.9062 7.14063 12 7 12 6.88281V5.14844Z'
    ]
};
const facSearch = {
    prefix: 'fac',
    iconName: 'search',
    icon: [
        14,
        14,
        [],
        '',
        'M10.0121 8.80864H9.37604L9.15191 8.59259C10.0284 7.5714 10.4752 6.25032 10.3985 4.90673C10.3217 3.56313 9.72741 2.30153 8.7403 1.38679C7.75318 0.472061 6.45005 -0.024653 5.10451 0.00094224C3.75897 0.0265374 2.47568 0.57245 1.52406 1.52406C0.57245 2.47568 0.0265374 3.75897 0.00094224 5.10451C-0.024653 6.45005 0.472061 7.75318 1.38679 8.7403C2.30153 9.72741 3.56313 10.3217 4.90673 10.3985C6.25032 10.4752 7.5714 10.0284 8.59259 9.1519L8.80864 9.37603V10.0121L12.8046 14L13.996 12.8087L10.0121 8.80864ZM5.21649 8.80864C4.50494 8.80884 3.80932 8.59801 3.21761 8.20282C2.6259 7.80763 2.16468 7.24584 1.89229 6.58849C1.6199 5.93115 1.54858 5.20779 1.68734 4.50991C1.82611 3.81202 2.16873 3.17097 2.67187 2.66783C3.17501 2.16469 3.81606 1.82207 4.51394 1.68331C5.21183 1.54454 5.93519 1.61586 6.59253 1.88825C7.24988 2.16064 7.81167 2.62186 8.20686 3.21357C8.60205 3.80528 8.81288 4.5009 8.81268 5.21245C8.81321 5.68519 8.72042 6.1534 8.53963 6.59021C8.35884 7.02703 8.09361 7.42386 7.75914 7.75796C7.42467 8.09205 7.02754 8.35684 6.59052 8.53714C6.1535 8.71744 5.68519 8.8097 5.21245 8.80864H5.21649Z'
    ]
};
const facExclamation = {
    prefix: 'fac',
    iconName: 'facExclamation',
    icon: [24, 24, [], '', 'M12 5V16M12 18.99V19'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowDownInCircle = {
    prefix: 'fac',
    iconName: 'facArrowDownInCircle',
    icon: [
        22,
        22,
        [],
        '',
        'M7 11L11 15M11 15L15 11M11 15V7M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowLeftInCircle = {
    prefix: 'fac',
    iconName: 'facArrowLeftInCircle',
    icon: [
        22,
        22,
        [],
        '',
        'M11 7L7 11M7 11L11 15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowRightInCircle = {
    prefix: 'fac',
    iconName: 'facArrowRightInCircle',
    icon: [
        22,
        22,
        [],
        '',
        'M11 15L15 11M15 11L11 7M15 11H7M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowUpInCircle = {
    prefix: 'fac',
    iconName: 'facArrowUpInCircle',
    icon: [
        22,
        22,
        [],
        '',
        'M15 11L11 7M11 7L7 11M11 7V15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facExclamationCircle = {
    prefix: 'fac',
    iconName: 'facExclamationCircle',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M12 8V12 M12 17C12.2761 17 12.5 16.7761 12.5 16.5C12.5 16.2239 12.2761 16 12 16C11.7239 16 11.5 16.2239 11.5 16.5C11.5 16.7761 11.7239 17 12 17Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facBuildFailure = {
    prefix: 'fac',
    iconName: 'facBuildFailure',
    icon: [24, 24, [], '', 'M18 6L6 18 M6 6L18 18'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const failIcon = {
    prefix: 'fac',
    iconName: 'fail',
    icon: [
        22,
        22,
        [],
        '',
        'M3.93 3.93L18.07 18.07M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facBuildSuccess = {
    prefix: 'fac',
    iconName: 'facBuildSuccess',
    icon: [24, 24, [], '', 'M20 6L9 17L4 12'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facPending = {
    prefix: 'fac',
    iconName: 'facPending',
    icon: [
        14,
        14,
        [],
        '',
        'M6.265 1.04445V0C4.9 0.133 3.598 0.658 2.534 1.54L3.26899 2.30069C4.11252 1.63007 5.14073 1.18178 6.265 1.04445ZM3.25348 11.6867C4.0999 12.3642 5.13383 12.8172 6.265 12.9553V13.958C4.893 13.811 3.591 13.258 2.534 12.376L3.25348 11.6867ZM1.03568 7.658C1.15907 8.78899 1.59677 9.82553 2.25958 10.6784L1.554 11.389C0.686 10.325 0.147 9.03 0.00699999 7.658H1.03568ZM2.29553 3.27553C1.6292 4.11608 1.18336 5.13937 1.04541 6.258H0C0.14 4.886 0.665 3.591 1.547 2.527L2.29553 3.27553Z M7.66748 0.0140046V0C10.9796 0.329109 13.6194 2.95498 13.9346 6.28107C14.3197 10.1323 11.5188 13.5495 7.66748 13.9346V12.9633C10.6671 12.6313 13 10.0881 13 7C13 3.91191 10.6671 1.36871 7.66748 1.03671V0.0140046Z M7.31744 3.48047V7.15668L10.4685 9.0263L9.9433 9.88758L6.26709 7.68186V3.48047H7.31744Z'
    ]
};
const facStart = {
    prefix: 'fac',
    iconName: 'facStart',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M10 8L16 12L10 16V8Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facResume = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.265 2.04445V1C5.9 1.133 4.598 1.658 3.534 2.54L4.26899 3.30069C5.11252 2.63007 6.14073 2.18178 7.265 2.04445ZM4.25348 12.6867C5.0999 13.3642 6.13383 13.8172 7.265 13.9553V14.958C5.893 14.811 4.591 14.258 3.534 13.376L4.25348 12.6867ZM2.03568 8.658C2.15907 9.78899 2.59677 10.8255 3.25958 11.6784L2.554 12.389C1.686 11.325 1.147 10.03 1.007 8.658H2.03568ZM3.29553 4.27553C2.6292 5.11608 2.18336 6.13937 2.04541 7.258H1C1.14 5.886 1.665 4.591 2.547 3.527L3.29553 4.27553Z" fill="#327DE2"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.66797 1.014V1C11.9801 1.32911 14.6199 3.95498 14.935 7.28107C15.3202 11.1323 12.5192 14.5495 8.66797 14.9346V13.9633C11.6675 13.6313 14.0005 11.0881 14.0005 8C14.0005 4.91191 11.6675 2.36871 8.66797 2.03671V1.014Z" fill="#327DE2"/>' +
    '<path d="M6.5 11L10.5 8L6.5 5V11Z" fill="#327DE2"/>' +
    '</svg>';
const facPortfolio = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M13.3335 4.66675H2.66683C1.93045 4.66675 1.3335 5.2637 1.3335 6.00008V12.6667C1.3335 13.4031 1.93045 14.0001 2.66683 14.0001H13.3335C14.0699 14.0001 14.6668 13.4031 14.6668 12.6667V6.00008C14.6668 5.2637 14.0699 4.66675 13.3335 4.66675Z" stroke="#747474" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M10.6668 14V3.33333C10.6668 2.97971 10.5264 2.64057 10.2763 2.39052C10.0263 2.14048 9.68712 2 9.3335 2H6.66683C6.31321 2 5.97407 2.14048 5.72402 2.39052C5.47397 2.64057 5.3335 2.97971 5.3335 3.33333V14" stroke="#747474" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
const facStop = {
    prefix: 'fac',
    iconName: 'facStop',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M15 9H9V15H15V9Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facLogs = {
    prefix: 'fac',
    iconName: 'facLogs',
    icon: [
        14,
        14,
        [],
        '',
        'M5,9.65039 L5,10.35039 L1,10.35039 L1,9.65039 L5,9.65039 Z M10,7.90039 L10,8.60039 L1,8.60039 L1,7.90039 L10,7.90039 Z M10,6.15039 L10,6.85039 L1,6.85039 L1,6.15039 L10,6.15039 Z M10,4.40039 L10,5.10039 L1,5.10039 L1,4.40039 L10,4.40039 Z M10,2.7002 L10,3.4002 L1,3.4002 L1,2.7002 L10,2.7002 Z M7.12803,10.5 L7.12803,14.2113 L8.67382,14.2113 L8.67382,15.1392 L6.2002,15.1392 L6.2002,10.5 L7.12803,10.5 Z M11.1555,10.5 C11.6658,10.5 12.0833,10.9175 12.0833,11.4278 L12.0833,11.4278 L12.0833,14.2113 C12.0833,14.7216 11.6658,15.1392 11.1555,15.1392 L11.1555,15.1392 L10.2276,15.1392 C9.71733,15.1392 9.2998,14.7216 9.2998,14.2113 L9.2998,14.2113 L9.2998,11.4278 C9.2998,10.9175 9.71733,10.5 10.2276,10.5 L10.2276,10.5 Z M15.6839,10.5 L15.6839,11.4278 L13.8282,11.4278 L13.8282,14.2113 L14.7561,14.2113 L14.7561,12.3557 L15.6839,12.3557 L15.6839,14.2113 C15.6839,14.7216 15.2664,15.1392 14.7561,15.1392 L14.7561,15.1392 L13.8282,15.1392 C13.3179,15.1392 12.9004,14.7216 12.9004,14.2113 L12.9004,14.2113 L12.9004,11.4278 C12.9004,10.9175 13.3179,10.5 13.8282,10.5 L13.8282,10.5 L15.6839,10.5 Z M11.1555,11.4278 L10.2276,11.4278 L10.2276,14.2113 L11.1555,14.2113 L11.1555,11.4278 Z'
    ]
};
const facChevronUp = {
    prefix: 'fac',
    iconName: 'chevron-up',
    icon: [24, 24, [], '', 'M18 15L12 9L6 15'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facChevronDown = {
    prefix: 'fac',
    iconName: 'chevron-down',
    icon: [24, 24, [], '', 'M6 9L12 15L18 9'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facChevronRight = {
    prefix: 'fac',
    iconName: 'chevron-right',
    icon: [24, 24, [], '', 'M9 18L15 12L9 6'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facChevronLeft = {
    prefix: 'fac',
    iconName: 'chevron-left',
    icon: [24, 24, [], '', 'M15 18L9 12L15 6'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facScrollerLeft = {
    prefix: 'fac',
    iconName: 'scroller-left',
    icon: [
        16,
        16,
        [],
        '',
        'M1.3334899999999994,8.00016a6.66667,6.66667 0 1,0 13.33334,0a6.66667,6.66667 0 1,0 -13.33334,0 M8.6665 6L6.6665 8L8.6665 10'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facScrollerRight = {
    prefix: 'fac',
    iconName: 'scroller-right',
    icon: [
        16,
        16,
        [],
        '',
        'M1.3334899999999994,8.00016a6.66667,6.66667 0 1,0 13.33334,0a6.66667,6.66667 0 1,0 -13.33334,0 M7.3335 10L9.3335 8L7.3335 6'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facTimes = {
    prefix: 'fac',
    iconName: 'times',
    icon: [
        12,
        12,
        [],
        '',
        'M3.46642 8.5338C3.27115 8.33854 3.27115 8.02195 3.46642 7.82669L7.82691 3.4662C8.02217 3.27094 8.33875 3.27094 8.53402 3.4662C8.72928 3.66146 8.72928 3.97804 8.53402 4.17331L4.17352 8.5338C3.97826 8.72906 3.66168 8.72906 3.46642 8.5338Z M3.46642 3.4662C3.66168 3.27094 3.97826 3.27094 4.17352 3.4662L8.53402 7.82669C8.72928 8.02196 8.72928 8.33854 8.53402 8.5338C8.33875 8.72906 8.02217 8.72906 7.82691 8.5338L3.46642 4.17331C3.27115 3.97805 3.27115 3.66146 3.46642 3.4662Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none'
    }
};
const facBars = {
    prefix: 'fac',
    iconName: 'bars',
    icon: [24, 24, [], '', 'M3 12H21 M3 6H21 M3 18H21'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facEyeOpen = {
    prefix: 'fac',
    iconName: 'facEyeOpen',
    icon: [
        24,
        24,
        [],
        '',
        'M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facEyeOff = {
    prefix: 'fac',
    iconName: 'eyeOff',
    icon: [
        24,
        24,
        [],
        '',
        'M9.9 4.24002C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003L17.94 17.94Z M1 1L23 23'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facLock = {
    prefix: 'fac',
    iconName: 'facLock',
    icon: [
        16,
        16,
        [],
        '',
        'M4.02141 8.02981C3.95982 8.07772 3.9001 8.16246 3.9001 8.37461V13.6246C3.9001 13.8368 3.95982 13.9215 4.02141 13.9694C4.1041 14.0337 4.27862 14.0996 4.6251 14.0996H11.3751C11.7216 14.0996 11.8961 14.0337 11.9788 13.9694C12.0404 13.9215 12.1001 13.8368 12.1001 13.6246V8.37461C12.1001 8.16246 12.0404 8.07772 11.9788 8.02981C11.8961 7.9655 11.7216 7.89961 11.3751 7.89961H4.6251C4.27862 7.89961 4.1041 7.9655 4.02141 8.02981ZM3.53026 7.39833C3.81889 7.17384 4.20688 7.09961 4.6251 7.09961H11.3751C11.7933 7.09961 12.1813 7.17384 12.4699 7.39833C12.7797 7.63923 12.9001 7.99199 12.9001 8.37461V13.6246C12.9001 14.0072 12.7797 14.36 12.4699 14.6009C12.1813 14.8254 11.7933 14.8996 11.3751 14.8996H4.6251C4.20688 14.8996 3.81889 14.8254 3.53026 14.6009C3.22053 14.36 3.1001 14.0072 3.1001 13.6246V8.37461C3.1001 7.99199 3.22053 7.63923 3.53026 7.39833Z M4.6001 5.49961C4.6001 3.62184 6.12233 2.09961 8.0001 2.09961C9.87787 2.09961 11.4001 3.62184 11.4001 5.49961V7.89961H4.6001V5.49961ZM8.0001 2.89961C6.56416 2.89961 5.4001 4.06367 5.4001 5.49961V7.09961H10.6001V5.49961C10.6001 4.06367 9.43604 2.89961 8.0001 2.89961Z M7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11Z'
    ]
};
const facExclamationTriangle = {
    prefix: 'fac',
    iconName: 'exclamationTriangle',
    icon: [
        24,
        24,
        [],
        '',
        'M10.2898 3.8602L1.81978 18.0002C1.64514 18.3026 1.55274 18.6455 1.55177 18.9947C1.55079 19.3439 1.64127 19.6873 1.8142 19.9907C1.98714 20.2941 2.2365 20.547 2.53748 20.7241C2.83847 20.9012 3.18058 20.9964 3.52978 21.0002H20.4698C20.819 20.9964 21.1611 20.9012 21.4621 20.7241C21.7631 20.547 22.0124 20.2941 22.1854 19.9907C22.3583 19.6873 22.4488 19.3439 22.4478 18.9947C22.4468 18.6455 22.3544 18.3026 22.1798 18.0002L13.7098 3.8602C13.5315 3.56631 13.2805 3.32332 12.981 3.15469C12.6814 2.98605 12.3435 2.89746 11.9998 2.89746C11.656 2.89746 11.3181 2.98605 11.0186 3.15469C10.7191 3.32332 10.468 3.56631 10.2898 3.8602V3.8602Z M12 9V13 M12 17H12.01'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facExclamationTriangleSVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M10.2898 3.8602L1.81978 18.0002C1.64514 18.3026 1.55274 18.6455 1.55177 18.9947C1.55079 19.3439 1.64127 19.6873 1.8142 19.9907C1.98714 20.2941 2.2365 20.547 2.53748 20.7241C2.83847 20.9012 3.18058 20.9964 3.52978 21.0002H20.4698C20.819 20.9964 21.1611 20.9012 21.4621 20.7241C21.7631 20.547 22.0124 20.2941 22.1854 19.9907C22.3583 19.6873 22.4488 19.3439 22.4478 18.9947C22.4468 18.6455 22.3544 18.3026 22.1798 18.0002L13.7098 3.8602C13.5315 3.56631 13.2805 3.32332 12.981 3.15469C12.6814 2.98605 12.3435 2.89746 11.9998 2.89746C11.656 2.89746 11.3181 2.98605 11.0186 3.15469C10.7191 3.32332 10.468 3.56631 10.2898 3.8602V3.8602Z" stroke="#FFBC1F" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M12 9V13" stroke="#FFBC1F" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M12 17H12.01" stroke="#FFBC1F" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const facCheck = {
    prefix: 'fac',
    iconName: 'check',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M17 9L11 15.01L8 12.01'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facPlusCircle = {
    prefix: 'fac',
    iconName: 'plusCircle',
    icon: [
        16,
        16,
        [],
        '',
        'M7.99992 5.33331V10.6666M5.33325 7.99998H10.6666M14.6666 7.99998C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99998C1.33325 4.31808 4.31802 1.33331 7.99992 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facMinusCircle = {
    prefix: 'fac',
    iconName: 'minusCircle',
    icon: [
        16,
        16,
        [],
        '',
        'M5.33325 8H10.6666M14.6666 8C14.6666 11.6819 11.6818 14.6667 7.99992 14.6667C4.31802 14.6667 1.33325 11.6819 1.33325 8C1.33325 4.3181 4.31802 1.33333 7.99992 1.33333C11.6818 1.33333 14.6666 4.3181 14.6666 8Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facCheckBroken = {
    prefix: 'fac',
    iconName: 'check-broken',
    icon: [
        22,
        22,
        [],
        '',
        'M21 10.08V11C20.9988 13.1564 20.3005 15.2547 19.0093 16.9818C17.7182 18.709 15.9033 19.9725 13.8354 20.5839C11.7674 21.1953 9.55726 21.1219 7.53447 20.3746C5.51168 19.6273 3.78465 18.2461 2.61096 16.4371C1.43727 14.628 0.879791 12.4881 1.02168 10.3363C1.16356 8.18455 1.99721 6.13631 3.39828 4.49706C4.79935 2.85781 6.69279 1.71537 8.79619 1.24013C10.8996 0.764896 13.1003 0.982323 15.07 1.85999M21 2.99999L11 13.01L8.00001 10.01'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const warning = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M8 9C7.86739 9 7.74021 8.94267 7.64645 8.84061C7.55268 8.73856 7.5 8.60014 7.5 8.45581V5.54419C7.5 5.39986 7.55268 5.26144 7.64645 5.15939C7.74021 5.05733 7.86739 5 8 5C8.13261 5 8.25979 5.05733 8.35355 5.15939C8.44732 5.26144 8.5 5.39986 8.5 5.54419V8.45581C8.5 8.60014 8.44732 8.73856 8.35355 8.84061C8.25979 8.94267 8.13261 9 8 9Z" fill="#FF9800"/>\n' +
    '<path d="M8 11C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10C7.72386 10 7.5 10.2239 7.5 10.5C7.5 10.7761 7.72386 11 8 11Z" fill="#FF9800"/>\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.77249 1.69137L0.692395 11.8456C0.567037 12.0628 0.500708 12.309 0.500006 12.5598C0.499304 12.8106 0.564254 13.0572 0.688394 13.2751C0.812534 13.4929 0.991537 13.6745 1.20759 13.8017C1.42365 13.9289 1.66923 13.9972 1.9199 14H14.0801C14.3308 13.9972 14.5763 13.9289 14.7924 13.8017C15.0085 13.6745 15.1875 13.4929 15.3116 13.2751C15.4357 13.0572 15.5007 12.8106 15.5 12.5598C15.4993 12.309 15.433 12.0628 15.3076 11.8456L9.22751 1.69137C9.09954 1.48032 8.91935 1.30582 8.70434 1.18472C8.48933 1.06362 8.24675 1 8 1C7.75325 1 7.51067 1.06362 7.29566 1.18472C7.08065 1.30582 6.90046 1.48032 6.77249 1.69137ZM14.4443 12.3505L8.37138 2.20815C8.33257 2.14479 8.27825 2.09244 8.2136 2.05602C8.14837 2.01929 8.0748 2 8 2C7.9252 2 7.85163 2.01929 7.7864 2.05602C7.72174 2.09245 7.66741 2.14481 7.6286 2.20818L1.55566 12.3505C1.51939 12.4153 1.50021 12.4883 1.5 12.5626C1.49979 12.6389 1.51954 12.7138 1.55726 12.78C1.59497 12.8462 1.64933 12.9013 1.71488 12.9399C1.77931 12.9778 1.85237 12.9985 1.92701 13H14.073C14.1476 12.9985 14.2207 12.9778 14.2851 12.9399C14.3507 12.9013 14.405 12.8462 14.4427 12.78C14.4805 12.7138 14.5002 12.6389 14.5 12.5626C14.4998 12.4883 14.4806 12.4153 14.4443 12.3505Z" fill="#FF9800"/>\n' +
    '</svg>';
const facEditorExecution = '<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M8.05 0C8.4366 0 8.75 0.313401 8.75 0.7V2.8C8.75 3.1866 8.4366 3.5 8.05 3.5H5.95C5.5634 3.5 5.25 3.1866 5.25 2.8V0.7C5.25 0.313401 5.5634 0 5.95 0H8.05ZM5.95 0.7V2.8H8.05V0.7H5.95Z" fill="#747474"/>' +
    '<path d="M8.05 8C8.4366 8 8.75 8.3134 8.75 8.7V10.8C8.75 11.1866 8.4366 11.5 8.05 11.5H5.95C5.5634 11.5 5.25 11.1866 5.25 10.8V8.7C5.25 8.3134 5.5634 8 5.95 8H8.05ZM5.95 8.7V10.8H8.05V8.7H5.95Z" fill="#747474"/>' +
    '<path d="M2.8 8C3.1866 8 3.5 8.3134 3.5 8.7V10.8C3.5 11.1866 3.1866 11.5 2.8 11.5H0.7C0.313401 11.5 0 11.1866 0 10.8V8.7C0 8.3134 0.313401 8 0.7 8H2.8ZM0.7 8.7V10.8H2.8V8.7H0.7Z" fill="#747474"/>' +
    '<path d="M7.25 3.25L7.2498 5.749L12.7 5.75C12.7 5.75 12.7 5.83579 12.7 6.25L7.2498 6.249L7.25 8.25H6.75L6.7498 6.249L2.2998 6.25C2.16173 6.25 2.0498 6.36193 2.0498 6.5V8.2H1.5498V6.5C1.5498 6.08579 1.88559 5.75 2.2998 5.75L6.7498 5.749L6.75 3.25H7.25Z" fill="#747474"/>' +
    '<path d="M14.7586 6.98754L14.7585 6.98757L14.7625 6.99144C15.3236 7.54492 15.6 8.20663 15.6 9C15.6 9.7935 15.3235 10.4607 14.7605 11.0236C14.2075 11.5767 13.5452 11.85 12.75 11.85C11.9556 11.85 11.2885 11.5771 10.7264 11.0236C10.1729 10.4615 9.9 9.79434 9.9 9C9.9 8.20484 10.1733 7.54255 10.7264 6.9895C11.2893 6.42655 11.9565 6.15 12.75 6.15C13.5434 6.15 14.2051 6.42637 14.7586 6.98754Z" stroke="#327DE2" stroke-width="0.8"/>' +
    '<path d="M13.5052 10.3037L12.1777 9.31514C12.1256 9.27263 12.0996 9.21948 12.0996 9.15571V7.54093C12.0996 7.41338 12.1621 7.34961 12.287 7.34961H12.7868C12.9117 7.34961 12.9742 7.41338 12.9742 7.54093V8.80494L14.0205 9.57024C14.1143 9.64465 14.1247 9.73499 14.0518 9.84129L13.7707 10.2558C13.6978 10.3621 13.6093 10.3781 13.5052 10.3037Z" fill="#327DE2"/>' +
    '</svg>';
const fullStarBlue = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1202 13.8362C11.8414 14.0388 11.4684 14.0548 11.1734 13.8767L8.27071 12.1248L5.36806 13.8767C5.07319 14.0547 4.70044 14.0389 4.42169 13.8366C4.14295 13.6343 4.01236 13.2848 4.09016 12.9493L4.856 9.64624L2.29536 7.42388C2.03535 7.19822 1.93559 6.83889 2.04205 6.51148C2.14851 6.18408 2.44053 5.95214 2.78354 5.92257L6.16202 5.63124L7.48171 2.52223C7.6161 2.20561 7.92675 2 8.27071 2C8.61467 2 8.92532 2.20561 9.05972 2.52223L10.3794 5.63124L13.7579 5.92257C14.101 5.95216 14.3931 6.18427 14.4995 6.51185C14.6059 6.83944 14.5058 7.19887 14.2455 7.42439L11.6807 9.64624L12.451 12.9481C12.5293 13.2837 12.399 13.6336 12.1202 13.8362Z" fill="#C6DBF7"/>\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1202 13.8362C11.8414 14.0388 11.4684 14.0548 11.1734 13.8767L8.27071 12.1248L5.36806 13.8767C5.07319 14.0547 4.70044 14.0389 4.42169 13.8366C4.14295 13.6343 4.01236 13.2848 4.09016 12.9493L4.856 9.64624L2.29536 7.42388C2.03535 7.19822 1.93559 6.83889 2.04205 6.51148C2.14851 6.18408 2.44053 5.95214 2.78354 5.92257L6.16202 5.63124L7.48171 2.52223C7.6161 2.20561 7.92675 2 8.27071 2C8.61467 2 8.92532 2.20561 9.05972 2.52223L10.3794 5.63124L13.7579 5.92257C14.101 5.95216 14.3931 6.18427 14.4995 6.51185C14.6059 6.83944 14.5058 7.19887 14.2455 7.42439L11.6807 9.64624L12.451 12.9481C12.5293 13.2837 12.399 13.6336 12.1202 13.8362ZM9.79192 6.4409L13.6842 6.77654L10.7285 9.33714L11.6163 13.1429L8.27071 11.1236L4.92515 13.1429L5.80755 9.33714L2.85718 6.77654L6.74951 6.4409L8.27071 2.85714L9.79192 6.4409Z" fill="#327DE2"/>\n' +
    '</svg>';
const fullStarBlueBigger = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1803 20.7543C17.7621 21.0582 17.2026 21.0822 16.76 20.815L12.4061 18.1872L8.0521 20.815C7.60979 21.082 7.05065 21.0583 6.63254 20.7548C6.21442 20.4514 6.01854 19.9272 6.13524 19.4239L7.28401 14.4694L3.44304 11.1358C3.05302 10.7973 2.90338 10.2583 3.06307 9.76723C3.22276 9.27612 3.6608 8.92822 4.17531 8.88385L9.24304 8.44686L11.2226 3.78335C11.4242 3.30842 11.8901 3 12.4061 3C12.922 3 13.388 3.30842 13.5896 3.78335L15.5691 8.44686L20.6368 8.88385C21.1515 8.92824 21.5897 9.2764 21.7492 9.76778C21.9088 10.2592 21.7587 10.7983 21.3682 11.1366L17.5211 14.4694L18.6765 19.4222C18.794 19.9256 18.5985 20.4504 18.1803 20.7543Z" fill="#C6DBF7"/>\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1803 20.7543C17.7621 21.0582 17.2026 21.0822 16.76 20.815L12.4061 18.1872L8.0521 20.815C7.60979 21.082 7.05065 21.0583 6.63254 20.7548C6.21442 20.4514 6.01854 19.9272 6.13524 19.4239L7.28401 14.4694L3.44304 11.1358C3.05302 10.7973 2.90338 10.2583 3.06307 9.76723C3.22276 9.27612 3.6608 8.92822 4.17531 8.88385L9.24304 8.44686L11.2226 3.78335C11.4242 3.30842 11.8901 3 12.4061 3C12.922 3 13.388 3.30842 13.5896 3.78335L15.5691 8.44686L20.6368 8.88385C21.1516 8.92824 21.5897 9.2764 21.7492 9.76778C21.9088 10.2592 21.7587 10.7983 21.3682 11.1366L17.5211 14.4694L18.6765 19.4222C18.794 19.9256 18.5985 20.4504 18.1803 20.7543ZM14.6879 9.66135L20.5264 10.1648L16.0927 14.0057L17.4244 19.7143L12.4061 16.6854L7.38772 19.7143L8.71133 14.0057L4.28577 10.1648L10.1243 9.66135L12.4061 4.28571L14.6879 9.66135Z" fill="#327DE2"/>\n' +
    '</svg>';
const emptyStar = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1202 13.8362C11.8414 14.0388 11.4684 14.0548 11.1734 13.8767L8.27071 12.1248L5.36806 13.8767C5.07319 14.0547 4.70044 14.0389 4.42169 13.8366C4.14295 13.6343 4.01236 13.2848 4.09016 12.9493L4.856 9.64624L2.29536 7.42388C2.03535 7.19822 1.93559 6.83889 2.04205 6.51148C2.14851 6.18408 2.44053 5.95214 2.78354 5.92257L6.16202 5.63124L7.48171 2.52223C7.6161 2.20561 7.92675 2 8.27071 2C8.61467 2 8.92532 2.20561 9.05972 2.52223L10.3794 5.63124L13.7579 5.92257C14.101 5.95216 14.3931 6.18427 14.4995 6.51185C14.6059 6.83944 14.5058 7.19887 14.2455 7.42439L11.6807 9.64624L12.451 12.9481C12.5293 13.2837 12.399 13.6336 12.1202 13.8362ZM9.79192 6.4409L13.6842 6.77654L10.7285 9.33714L11.6163 13.1429L8.27071 11.1236L4.92515 13.1429L5.80755 9.33714L2.85718 6.77654L6.74951 6.4409L8.27071 2.85714L9.79192 6.4409Z" fill="#BDC1C6"/>\n' +
    '</svg>';
const emptyStarBigger = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.1803 20.7543C17.7621 21.0582 17.2026 21.0822 16.76 20.815L12.4061 18.1872L8.0521 20.815C7.60979 21.082 7.05065 21.0583 6.63254 20.7548C6.21442 20.4514 6.01854 19.9272 6.13524 19.4239L7.28401 14.4694L3.44304 11.1358C3.05302 10.7973 2.90338 10.2583 3.06307 9.76723C3.22276 9.27612 3.6608 8.92822 4.17531 8.88385L9.24304 8.44686L11.2226 3.78335C11.4242 3.30842 11.8901 3 12.4061 3C12.922 3 13.388 3.30842 13.5896 3.78335L15.5691 8.44686L20.6368 8.88385C21.1515 8.92823 21.5897 9.2764 21.7492 9.76778C21.9088 10.2592 21.7587 10.7983 21.3682 11.1366L17.5211 14.4694L18.6765 19.4222C18.794 19.9256 18.5985 20.4504 18.1803 20.7543ZM14.6879 9.66135L20.5264 10.1648L16.0927 14.0057L17.4244 19.7143L12.4061 16.6854L7.38772 19.7143L8.71133 14.0057L4.28577 10.1648L10.1243 9.66135L12.4061 4.28571L14.6879 9.66135Z" fill="#BDC1C6"/>\n' +
    '</svg>';
const facReject = {
    prefix: 'fac',
    iconName: 'reject',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M15 9L9 15 M9 9L15 15'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSimpleCheck = {
    prefix: 'fac',
    iconName: 'simpleCheck',
    icon: [
        14,
        14,
        [],
        '',
        'M6.57031 9.86587L4.77485 7.98533L4 8.79498L5.81711 10.6695C5.91687 10.7743 6.03547 10.8574 6.1661 10.9141C6.29672 10.9708 6.4368 11 6.57827 11C6.71974 11 6.85982 10.9708 6.99045 10.9141C7.12108 10.8574 7.23968 10.7743 7.33943 10.6695L12 5.80367L11.2258 5L6.57031 9.86587Z'
    ]
};
const facOpen = {
    prefix: 'fac',
    iconName: 'open',
    icon: [24, 24, [], '', 'M11 17L6 12L11 7 M18 17L13 12L18 7'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const boldBell = {
    prefix: 'fac',
    iconName: 'boldBell',
    icon: [
        11.49996280670166,
        13,
        [],
        '',
        'M8.24976 14C9.07757 14 9.74905 13.3285 9.74905 12.5H6.75047C6.75047 13.3285 7.42195 14 8.24976 14ZM13.2979 10.4912C12.8451 10.0046 11.9979 9.27266 11.9979 6.875C11.9979 5.05391 10.721 3.59609 8.99929 3.23844V2.75C8.99929 2.33586 8.66366 2 8.24976 2C7.83585 2 7.50023 2.33586 7.50023 2.75V3.23844C5.77852 3.59609 4.50164 5.05391 4.50164 6.875C4.50164 9.27266 3.65438 10.0046 3.20157 10.4912C3.06094 10.6423 2.9986 10.823 2.99977 11C3.00235 11.3844 3.30399 11.75 3.75211 11.75H12.7474C13.1955 11.75 13.4974 11.3844 13.4997 11C13.5009 10.823 13.4386 10.6421 13.2979 10.4912Z'
    ],
    customStyles: {
        fill: 'currentColor'
    },
    pathAttrs: {
        transform: 'translate(-2.499753713607788, -1.5)'
    }
};
const ellipsis = {
    prefix: 'fac',
    iconName: 'ellipsis',
    icon: [
        14,
        14,
        [],
        '',
        'M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z'
    ],
    customStyles: {
        fill: 'currentColor'
    },
    pathAttrs: {
        transform: 'translate(-0.994, -0.98)'
    }
};
const leftBottomArrow = {
    prefix: 'fac',
    iconName: 'leftBottomArrow',
    icon: [12, 12, [], '', 'M11 1L1 11M1 11H11M1 11V1'],
    customStyles: {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        stroke: 'currentColor'
    }
};
const leftTopArrow = {
    prefix: 'fac',
    iconName: 'leftTopArrow',
    icon: [12, 12, [], '', 'M11 11L1 1M1 1V11M1 1H11'],
    customStyles: {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        stroke: 'currentColor'
    }
};
const rightBottomArrow = {
    prefix: 'fac',
    iconName: 'rightBottomArrow',
    icon: [12, 12, [], '', 'M1 1L11 11M11 11V1M11 11H1'],
    customStyles: {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        stroke: 'currentColor'
    }
};
const rightTopArrow = {
    prefix: 'fac',
    iconName: 'rightTopArrow',
    icon: [12, 12, [], '', 'M1 11L11 1M11 1H1M11 1V11'],
    customStyles: {
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        stroke: 'currentColor'
    }
};
const facAlert = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#FB4E4E"/>\n' +
    '<path d="M12 8V12" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M12 16H12.01" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const facApproveCheckMark = '<svg width="22" height="12" viewBox="0 0 10 14" stroke="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path\n' +
    'd="M5.14063 9.73173L1.5497 5.97065L0 7.58995L3.63422 11.3391C3.83374 11.5485 4.07094 11.7148 4.33219 11.8282C4.59345 11.9416 4.8736 12 5.15655 12C5.43949 12 5.71964 11.9416 5.9809 11.8282C6.24215 11.7148 6.47936 11.5485 6.67887 11.3391L16 1.60733L14.4516 0L5.14063 9.73173Z"\n' +
    'fill="#327DE2"\n' +
    '/>\n' +
    '</svg>';
const facCalendar = {
    prefix: 'fac',
    iconName: 'calendar',
    icon: [
        16,
        16,
        [],
        '',
        'M5.92188 8.625H4.82812C4.60938 8.625 4.5 8.51562 4.5 8.29688V7.20312C4.5 6.98438 4.60938 6.875 4.82812 6.875H5.92188C6.14062 6.875 6.25 6.98438 6.25 7.20312V8.29688C6.25 8.51562 6.14062 8.625 5.92188 8.625ZM8.875 8.29688C8.875 8.51562 8.76562 8.625 8.54688 8.625H7.45312C7.23438 8.625 7.125 8.51562 7.125 8.29688V7.20312C7.125 6.98438 7.23438 6.875 7.45312 6.875H8.54688C8.76562 6.875 8.875 6.98438 8.875 7.20312V8.29688ZM11.5 8.29688C11.5 8.51562 11.3906 8.625 11.1719 8.625H10.0781C9.85938 8.625 9.75 8.51562 9.75 8.29688V7.20312C9.75 6.98438 9.85938 6.875 10.0781 6.875H11.1719C11.3906 6.875 11.5 6.98438 11.5 7.20312V8.29688ZM8.875 10.9219C8.875 11.1406 8.76562 11.25 8.54688 11.25H7.45312C7.23438 11.25 7.125 11.1406 7.125 10.9219V9.82812C7.125 9.60938 7.23438 9.5 7.45312 9.5H8.54688C8.76562 9.5 8.875 9.60938 8.875 9.82812V10.9219ZM6.25 10.9219C6.25 11.1406 6.14062 11.25 5.92188 11.25H4.82812C4.60938 11.25 4.5 11.1406 4.5 10.9219V9.82812C4.5 9.60938 4.60938 9.5 4.82812 9.5H5.92188C6.14062 9.5 6.25 9.60938 6.25 9.82812V10.9219ZM11.5 10.9219C11.5 11.1406 11.3906 11.25 11.1719 11.25H10.0781C9.85938 11.25 9.75 11.1406 9.75 10.9219V9.82812C9.75 9.60938 9.85938 9.5 10.0781 9.5H11.1719C11.3906 9.5 11.5 9.60938 11.5 9.82812V10.9219ZM14.125 3.8125V13.4375C14.125 13.8021 13.9974 14.112 13.7422 14.3672C13.487 14.6224 13.1771 14.75 12.8125 14.75H3.1875C2.82292 14.75 2.51302 14.6224 2.25781 14.3672C2.0026 14.112 1.875 13.8021 1.875 13.4375V3.8125C1.875 3.44792 2.0026 3.13802 2.25781 2.88281C2.51302 2.6276 2.82292 2.5 3.1875 2.5H4.5V1.07812C4.5 0.859375 4.60938 0.75 4.82812 0.75H5.92188C6.14062 0.75 6.25 0.859375 6.25 1.07812V2.5H9.75V1.07812C9.75 0.859375 9.85938 0.75 10.0781 0.75H11.1719C11.3906 0.75 11.5 0.859375 11.5 1.07812V2.5H12.8125C13.1771 2.5 13.487 2.6276 13.7422 2.88281C13.9974 3.13802 14.125 3.44792 14.125 3.8125ZM12.8125 13.2734V5.125H3.1875V13.2734C3.1875 13.3828 3.24219 13.4375 3.35156 13.4375H12.6484C12.7578 13.4375 12.8125 13.3828 12.8125 13.2734Z'
    ]
};
const timeDetails = {
    prefix: 'fac',
    iconName: 'timeDetails',
    icon: [
        24,
        24,
        [],
        '',
        'M1 3.99995V9.99995M1 9.99995H7M1 9.99995L5.64 5.63995C7.02091 4.26137 8.81245 3.36892 10.7447 3.09707C12.6769 2.82521 14.6451 3.18868 16.3528 4.13271C18.0605 5.07674 19.4152 6.55019 20.2126 8.33105C21.0101 10.1119 21.2072 12.1037 20.7742 14.0063C20.3413 15.9089 19.3017 17.6193 17.8121 18.8797C16.3226 20.1401 14.4637 20.8823 12.5157 20.9944C10.5677 21.1065 8.63598 20.5825 7.01166 19.5013C5.38734 18.4201 4.15839 16.8403 3.51 14.9999 M11.5 7.5V12.5L15.5 14.5'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const puzzleIcon = {
    prefix: 'fac',
    iconName: 'puzzle',
    icon: [
        24,
        24,
        [],
        '',
        'M18.6134 17.0796C19.2681 17.7603 20.1488 18.1353 21.0931 18.1353C21.6343 18.1353 22.1525 18.0129 22.6335 17.7715C22.7634 17.7062 22.8719 17.7576 22.9126 17.7826C22.9616 17.8129 23.0438 17.8837 23.0438 18.0187V23.0437H18.0187C17.8838 23.0437 17.813 22.9615 17.7827 22.9125C17.7577 22.8718 17.7064 22.7633 17.7716 22.6333C18.013 22.1524 18.1354 21.6342 18.1354 21.093C18.1354 20.1487 17.7604 19.268 17.0796 18.6134C16.4326 17.991 15.5912 17.653 14.6971 17.653C14.651 17.653 14.6046 17.6539 14.5581 17.6556C12.8066 17.7239 11.3582 19.1477 11.2607 20.897C11.2274 21.4969 11.3503 22.0952 11.6161 22.6273C11.6833 22.7619 11.631 22.8729 11.6053 22.9143C11.5755 22.9626 11.5054 23.0436 11.3716 23.0436H6.34683V18.0186C6.34683 17.5873 6.12801 17.1949 5.76152 16.9688C5.39248 16.7412 4.94007 16.7218 4.55134 16.9169C4.20482 17.0908 3.83096 17.179 3.44003 17.179C2.75819 17.179 2.12229 16.9083 1.64946 16.4166C1.17697 15.9253 0.931425 15.2784 0.95815 14.5951C1.00754 13.3309 2.03504 12.2856 3.29737 12.2153C3.73123 12.1913 4.16361 12.2796 4.54713 12.4713C4.93897 12.667 5.39396 12.6474 5.76424 12.4185C6.12911 12.193 6.34693 11.8015 6.34693 11.3715V6.34674H11.3719C11.8032 6.34674 12.1956 6.12792 12.4217 5.76142C12.6494 5.39243 12.6688 4.93997 12.4736 4.55124C12.2997 4.20473 12.2115 3.83087 12.2115 3.43994C12.2115 2.75809 12.4822 2.12224 12.9738 1.64946C13.4651 1.17697 14.1119 0.931136 14.7953 0.958052C16.0595 1.00734 17.1049 2.03484 17.1752 3.29718C17.1994 3.73133 17.1109 4.16347 16.9192 4.54708C16.7234 4.93897 16.7431 5.39396 16.972 5.76419C17.1975 6.12902 17.589 6.34684 18.019 6.34684H23.0438V11.3715C23.0438 11.5054 22.9628 11.5755 22.9145 11.6053C22.873 11.631 22.762 11.6832 22.6275 11.6161C22.0955 11.3503 21.4975 11.2272 20.8973 11.2607C19.148 11.3581 17.7242 12.8064 17.6558 14.558C17.6188 15.5035 17.959 16.3991 18.6134 17.0796Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSnail = {
    prefix: 'fac',
    iconName: 'snail',
    icon: [
        16,
        16,
        [],
        '',
        'M11.3187 1.80475C11.3599 2.08216 11.3125 2.36549 11.1833 2.61442C11.0542 2.86335 10.8498 3.06522 10.5993 3.1913C10.3488 3.31739 10.0649 3.36128 9.78801 3.31672C9.51112 3.27217 9.25534 3.14144 9.05703 2.94313C8.85872 2.74483 8.72799 2.48904 8.68344 2.21215C8.63888 1.93526 8.68277 1.65138 8.80886 1.40087C8.93495 1.15037 9.13681 0.945996 9.38574 0.816829C9.63468 0.687663 9.918 0.640278 10.1954 0.681416C10.4784 0.723377 10.7404 0.855237 10.9426 1.05752C11.1449 1.2598 11.2768 1.52177 11.3187 1.80475Z\n' +
            'M10.2863 8.3647C10.42 9.2663 10.266 10.1871 9.8462 10.9961C9.42641 11.8052 8.7622 12.4612 7.94806 12.871C7.13391 13.2808 6.21128 13.4234 5.3114 13.2786C4.41152 13.1338 3.58021 12.7089 2.93571 12.0645C2.29121 11.42 1.86635 10.5886 1.72154 9.68876C1.57674 8.78888 1.71937 7.86625 2.12916 7.0521C2.53894 6.23796 3.195 5.57375 4.00403 5.15396C4.81307 4.73417 5.73387 4.58017 6.63546 4.71387C7.55513 4.85024 8.40655 5.27879 9.06396 5.9362C9.72138 6.59361 10.1499 7.44503 10.2863 8.3647Z\n' +
            'M7.97836 8.70663C8.04007 9.12276 7.96899 9.54774 7.77524 9.92114C7.5815 10.2945 7.27494 10.5973 6.89918 10.7865C6.52342 10.9756 6.09759 11.0414 5.68226 10.9746C5.26693 10.9078 4.88325 10.7117 4.58579 10.4142C4.28833 10.1168 4.09224 9.73307 4.0254 9.31774C3.95857 8.90241 4.0244 8.47658 4.21353 8.10082C4.40266 7.72506 4.70546 7.41851 5.07886 7.22476C5.45226 7.03101 5.87724 6.95993 6.29337 7.02164C6.71783 7.08458 7.11079 7.28237 7.41421 7.58579C7.71763 7.88921 7.91542 8.28217 7.97836 8.70663Z\n' +
            'M15.3187 1.80475C15.3599 2.08216 15.3125 2.36549 15.1833 2.61442C15.0542 2.86335 14.8498 3.06522 14.5993 3.1913C14.3488 3.31739 14.0649 3.36128 13.788 3.31672C13.5111 3.27217 13.2553 3.14144 13.057 2.94313C12.8587 2.74483 12.728 2.48904 12.6834 2.21215C12.6389 1.93526 12.6828 1.65138 12.8089 1.40087C12.9349 1.15037 13.1368 0.945996 13.3857 0.816829C13.6347 0.687663 13.918 0.640278 14.1954 0.681416C14.4784 0.723377 14.7404 0.855237 14.9426 1.05752C15.1449 1.2598 15.2768 1.52177 15.3187 1.80475Z\n' +
            'M10.3333 9V7.33333C10.3333 6.97971 10.4738 6.64057 10.7239 6.39052C10.9739 6.14048 11.313 6 11.6667 6L12.3333 6C12.687 6 13.0261 6.14048 13.2761 6.39052C13.5262 6.64057 13.6667 6.97971 13.6667 7.33333V14C13.6667 14.3536 13.5262 14.6928 13.2761 14.9428C13.0261 15.1929 12.687 15.3333 12.3333 15.3333H9\n' +
            'M11.9998 15.333L0.666504 15.333L0.666504 14.6663C0.666504 14.3127 0.806979 13.9736 1.05703 13.7235C1.30708 13.4735 1.64622 13.333 1.99984 13.333L5.99984 13.333\n' +
            'M10.3335 3.33301L11.3335 5.99967 M13.6665 3.33301L12.6665 5.99967'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const wrench = {
    prefix: 'fac',
    iconName: 'wrench',
    icon: [
        21,
        21,
        [],
        '',
        'M12.7 5.29998C12.5168 5.48691 12.4141 5.73823 12.4141 5.99998C12.4141 6.26173 12.5168 6.51305 12.7 6.69998L14.3 8.29998C14.4869 8.48321 14.7382 8.58584 15 8.58584C15.2617 8.58584 15.513 8.48321 15.7 8.29998L19.47 4.52998C19.9728 5.64117 20.1251 6.87921 19.9064 8.07913C19.6878 9.27904 19.1087 10.3838 18.2463 11.2463C17.3838 12.1087 16.279 12.6878 15.0791 12.9064C13.8792 13.1251 12.6412 12.9728 11.53 12.47L4.61998 19.38C4.22215 19.7778 3.68259 20.0013 3.11998 20.0013C2.55737 20.0013 2.0178 19.7778 1.61998 19.38C1.22215 18.9822 0.998657 18.4426 0.998657 17.88C0.998657 17.3174 1.22215 16.7778 1.61998 16.38L8.52998 9.46998C8.02714 8.35879 7.87489 7.12075 8.09352 5.92083C8.31215 4.72092 8.89126 3.61614 9.7537 2.7537C10.6161 1.89127 11.7209 1.31215 12.9208 1.09352C14.1207 0.874895 15.3588 1.02714 16.47 1.52998L12.71 5.28998L12.7 5.29998Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const cubeIcon = {
    prefix: 'fac',
    iconName: 'cube',
    icon: [
        20,
        22,
        [],
        '',
        'M1.27 5.9599L10 11.0099L18.73 5.9599M10 21.0799V10.9999M19 14.9999V6.9999C18.9996 6.64918 18.9071 6.30471 18.7315 6.00106C18.556 5.69742 18.3037 5.44526 18 5.2699L11 1.2699C10.696 1.09437 10.3511 1.00195 10 1.00195C9.64893 1.00195 9.30404 1.09437 9 1.2699L2 5.2699C1.69626 5.44526 1.44398 5.69742 1.26846 6.00106C1.09294 6.30471 1.00036 6.64918 1 6.9999V14.9999C1.00036 15.3506 1.09294 15.6951 1.26846 15.9987C1.44398 16.3024 1.69626 16.5545 2 16.7299L9 20.7299C9.30404 20.9054 9.64893 20.9979 10 20.9979C10.3511 20.9979 10.696 20.9054 11 20.7299L18 16.7299C18.3037 16.5545 18.556 16.3024 18.7315 15.9987C18.9071 15.6951 18.9996 15.3506 19 14.9999Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const testPack = {
    prefix: 'fac',
    iconName: 'testPack',
    icon: [24, 20, [], '', 'M21 6V19H3V6M10 10H14M1 1H23V6H1V1Z'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facDoubleArrowDown = {
    prefix: 'fac',
    iconName: 'doubleArrowDown',
    icon: [24, 24, [], '', 'M7 13L12 18L17 13 M7 6L12 11L17 6'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facMenuEdit = '<svg width="16" height="16" viewBox="0 0 16 16">\n' +
    '            <path\n' +
    '                d="M7.98336 8.25065C8.30552 8.25065 8.56669 7.98948 8.56669 7.66732C8.56669 7.34515 8.30552 7.08398 7.98336 7.08398C7.66119 7.08398 7.40002 7.34515 7.40002 7.66732C7.40002 7.98948 7.66119 8.25065 7.98336 8.25065Z"\n' +
    '                stroke="#747474"\n' +
    '                stroke-linecap="round"\n' +
    '                stroke-linejoin="round"\n' +
    '            />\n' +
    '            <path\n' +
    '                d="M7.98336 4.16667C8.30552 4.16667 8.56669 3.9055 8.56669 3.58333C8.56669 3.26117 8.30552 3 7.98336 3C7.66119 3 7.40002 3.26117 7.40002 3.58333C7.40002 3.9055 7.66119 4.16667 7.98336 4.16667Z"\n' +
    '                stroke="#747474"\n' +
    '                stroke-linecap="round"\n' +
    '                stroke-linejoin="round"\n' +
    '            />\n' +
    '            <path\n' +
    '                d="M7.98336 12.3337C8.30552 12.3337 8.56669 12.0725 8.56669 11.7503C8.56669 11.4282 8.30552 11.167 7.98336 11.167C7.66119 11.167 7.40002 11.4282 7.40002 11.7503C7.40002 12.0725 7.66119 12.3337 7.98336 12.3337Z"\n' +
    '                stroke="#747474"\n' +
    '                stroke-linecap="round"\n' +
    '                stroke-linejoin="round"\n' +
    '            />\n' +
    '        </svg>';
const facEmailNotification = {
    prefix: 'fac',
    iconName: 'emailNotification',
    icon: [13, 13, [], '', 'M12 1L6 7 M12 1L8.15 12L5.95 7.05L1 4.85L12 1Z'],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facCustomNotification = {
    prefix: 'fac',
    iconName: 'customNotification',
    icon: [
        13,
        13,
        [],
        '',
        'M9.75 4.5C9.75 3.57174 9.38125 2.6815 8.72487 2.02513C8.0685 1.36875 7.17826 1 6.25 1C5.32174 1 4.4315 1.36875 3.77513 2.02513C3.11875 2.6815 2.75 3.57174 2.75 4.5C2.75 8.58333 1 9.75 1 9.75H11.5C11.5 9.75 9.75 8.58333 9.75 4.5Z M7.25954 12.083C7.15699 12.2598 7.00979 12.4066 6.83268 12.5086C6.65557 12.6106 6.45477 12.6643 6.25038 12.6643C6.04599 12.6643 5.84519 12.6106 5.66808 12.5086C5.49097 12.4066 5.34377 12.2598 5.24121 12.083'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const video = {
    prefix: 'fac',
    iconName: 'video',
    icon: [
        24,
        16,
        [],
        '',
        'M23 3L16 8L23 13V3Z M14 1H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H14C15.1046 15 16 14.1046 16 13V3C16 1.89543 15.1046 1 14 1Z'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const videoDisabled = {
    prefix: 'fac',
    iconName: 'videoDisabled',
    icon: [
        24,
        24,
        [],
        '',
        'M10.66 5H14C14.5304 5 15.0391 5.21071 15.4142 5.58579C15.7893 5.96086 16 6.46957 16 7V10.34L17 11.34L23 7V17M1 1L23 23M16 16V17C16 17.5304 15.7893 18.0391 15.4142 18.4142C15.0391 18.7893 14.5304 19 14 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5H5L16 16Z'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const rotationLeft = {
    prefix: 'fac',
    iconName: 'rotationLeft',
    icon: [
        22,
        20,
        [],
        '',
        'M1 2.00001V8.00001M1 8.00001H7M1 8.00001L5.64 3.64001C7.02091 2.26143 8.81245 1.36898 10.7447 1.09713C12.6769 0.825273 14.6451 1.18874 16.3528 2.13277C18.0605 3.0768 19.4152 4.55025 20.2126 6.33111C21.0101 8.11197 21.2072 10.1038 20.7742 12.0064C20.3413 13.909 19.3017 15.6194 17.8121 16.8798C16.3226 18.1402 14.4637 18.8824 12.5157 18.9945C10.5677 19.1066 8.63598 18.5826 7.01166 17.5014C5.38734 16.4202 4.15839 14.8404 3.51 13'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const rotationRight = {
    prefix: 'fac',
    iconName: 'rotationRight',
    icon: [
        22,
        20,
        [],
        '',
        'M21 2.00001V8.00001M21 8.00001H15M21 8.00001L16.37 3.64001C14.9906 2.25975 13.2 1.3652 11.268 1.09116C9.33593 0.817114 7.36717 1.17843 5.65836 2.12065C3.94954 3.06288 2.59325 4.53496 1.79386 6.31508C0.994479 8.0952 0.795309 10.0869 1.22637 11.9901C1.65743 13.8932 2.69536 15.6047 4.18376 16.8667C5.67216 18.1286 7.53038 18.8726 9.47842 18.9866C11.4265 19.1006 13.3588 18.5783 14.9842 17.4985C16.6096 16.4187 17.84 14.8399 18.49 13'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const halfRotationLeft = {
    prefix: 'fac',
    iconName: 'halfRotationLeft',
    icon: [
        24,
        24,
        [],
        '',
        'M20.9999 9V15M20.9999 15H14.9999M20.9999 15L18.3597 12.6307C16.9787 11.2521 15.187 10.3596 13.2546 10.0878C11.3223 9.81593 9.35388 10.1794 7.64607 11.1234C5.93826 12.0675 4.58353 13.5409 3.78601 15.3218'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const rotationLeftDot = {
    prefix: 'fac',
    iconName: 'rotationLeftWithDot',
    icon: [
        22,
        20,
        [],
        '',
        [
            'M1 2.00001V8.00001M1 8.00001H7M1 8.00001L5.64 3.64001C7.02091 2.26143 8.81245 1.36898 10.7447 1.09713C12.6769 0.825273 14.6451 1.18874 16.3528 2.13277C18.0605 3.0768 19.4152 4.55025 20.2126 6.33111C21.0101 8.11197 21.2072 10.1038 20.7742 12.0064C20.3413 13.909 19.3017 15.6194 17.8121 16.8798C16.3226 18.1402 14.4637 18.8824 12.5157 18.9945C10.5677 19.1066 8.63598 18.5826 7.01166 17.5014C5.38734 16.4202 4.15839 14.8404 3.51 13',
            'M14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z'
        ]
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none',
        '--fa-secondary-color': 'none',
        '--fa-secondary-opacity': '1'
    }
};
const sortingDown = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M3 12H15" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M3 6H9" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M3 18H21" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const sortingUp = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M3 12H15" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M3 6H21" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M3 18H9" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>\n';
const mail = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M22 6L12 13L2 6" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const facArrowForward = {
    prefix: 'fac',
    iconName: 'arrow-forward',
    icon: [24, 24, [], '', 'M3 12H17 M10 5L17 12L10 19 M21 20V4'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facArrowBack = {
    prefix: 'fac',
    iconName: 'arrow-back',
    icon: [24, 24, [], '', 'M21 12H7 M14 19L7 12L14 5 M3 20L3 4'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facQuestionInCircle = {
    prefix: 'fac',
    iconName: 'QuestionInCircle',
    icon: [
        24,
        24,
        [],
        '',
        'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M9.08984 8.99959C9.32495 8.33126 9.789 7.7677 10.3998 7.40873C11.0106 7.04975 11.7287 6.91853 12.427 7.0383C13.1253 7.15808 13.7587 7.52112 14.2149 8.06312C14.6712 8.60512 14.9209 9.29112 14.9198 9.99959C14.9198 11.9996 11.9198 12.9996 11.9198 12.9996 M12 17C12.2761 17 12.5 16.7761 12.5 16.5C12.5 16.2239 12.2761 16 12 16C11.7239 16 11.5 16.2239 11.5 16.5C11.5 16.7761 11.7239 17 12 17Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facExpand = {
    prefix: 'fac',
    iconName: 'facExpand',
    icon: [24, 24, [], '', 'M15 3H21V9 M9 21H3V15 M21 3L14 10 M3 21L10 14'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facCompress = {
    prefix: 'fac',
    iconName: 'facCompress',
    icon: [24, 24, [], '', 'M4 14H10V20 M20 10H14V4 M14 10L21 3 M3 21L10 14'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facStartPlay = {
    prefix: 'fac',
    iconName: 'startPlay',
    icon: [16, 20, [], '', 'M1 1L15 10L1 19V1Z'],
    customStyles: {
        fill: 'none',
        stroke: '#878787',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const breakPlay = {
    prefix: 'fac',
    iconName: 'breakPlay',
    icon: [
        20,
        20,
        [],
        '',
        'M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const pausePlay = {
    prefix: 'fac',
    iconName: 'pausePlay',
    icon: [14, 18, [], '', 'M5 1H1V17H5V1Z M13 1H9V17H13V1Z'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const backwardPlay = {
    prefix: 'fac',
    iconName: 'backwardPlay',
    icon: [16, 18, [], '', 'M1 16V2M15 17L5 9L15 1V17Z'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const forwardPlay = {
    prefix: 'fac',
    iconName: 'forwardPlay',
    icon: [16, 18, [], '', 'M15 2V16M1 1L11 9L1 17V1Z'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facResumePlay = {
    prefix: 'fac',
    iconName: 'resumePlay',
    icon: [
        24,
        24,
        [],
        '',
        'M11.5 21.4871V22.4883C8.98898 22.3706 6.70861 21.3709 4.96172 19.7919L5.71655 19.1253C7.27461 20.5004 9.28714 21.3723 11.5 21.4871ZM5.00066 18.4234C3.55302 16.8468 2.63114 14.7797 2.51293 12.5H1.51169C1.63047 15.0337 2.64727 17.3326 4.25098 19.0855L5.00066 18.4234ZM2.51293 11.5C2.62943 9.25322 3.52655 7.21294 4.93825 5.6452L4.23026 4.93722C2.63851 6.68726 1.62996 8.97722 1.51169 11.5H2.51293ZM11.5 2.51293C9.25329 2.62942 7.21308 3.52648 5.64537 4.93811L4.93738 4.23012C6.6874 2.63845 8.9773 1.62995 11.5 1.51169V2.51293ZM22.5 12C22.5 17.6314 18.0668 22.2273 12.5 22.4883V21.4871C17.5143 21.2271 21.5 17.079 21.5 12C21.5 6.92101 17.5143 2.77293 12.5 2.51293V1.51169C18.0668 1.77266 22.5 6.36862 22.5 12Z M10 8L16 12L10 16V8Z'
    ],
    customStyles: {
        fill: 'currentColor',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd',
        stroke: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const fileIcon = {
    prefix: 'fac',
    iconName: 'file',
    icon: [
        18,
        22,
        [],
        '',
        'M10 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V8M10 1L17 8M10 1V8H17'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSorting = {
    prefix: 'fac',
    iconName: 'sorting',
    icon: [
        24,
        24,
        [],
        '',
        'M2.75781 6.51465L7.00045 2.27201L11.2431 6.51465 M6.99955 2.27193V16.1714 M21.2431 17.4854L17.0005 21.728L12.7578 17.4854 M16.9996 21.7281V7.82857'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facInfoCircle = {
    prefix: 'fac',
    iconName: 'facInfoCircle',
    icon: [
        22,
        22,
        [],
        '',
        'M11 15V11M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11ZM11.5 7C11.5 7.27614 11.2761 7.5 11 7.5C10.7239 7.5 10.5 7.27614 10.5 7C10.5 6.72386 10.7239 6.5 11 6.5C11.2761 6.5 11.5 6.72386 11.5 7Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
    }
};
const FacHelpIcon = {
    prefix: 'fac',
    iconName: 'facHelpIcon',
    icon: [
        17,
        21,
        [],
        '',
        'M19.5 22C19.5 22.2761 19.7239 22.5 20 22.5C20.2761 22.5 20.5 22.2761 20.5 22H19.5ZM3.5 22C3.5 22.2761 3.72386 22.5 4 22.5C4.27614 22.5 4.5 22.2761 4.5 22H3.5ZM4 8V7.5C3.72386 7.5 3.5 7.72386 3.5 8H4ZM6 11V11.5C6.27614 11.5 6.5 11.2761 6.5 11H6ZM4 11H3.5C3.5 11.2761 3.72386 11.5 4 11.5V11ZM20 8H20.5C20.5 7.72386 20.2761 7.5 20 7.5V8ZM20 11V11.5C20.2761 11.5 20.5 11.2761 20.5 11H20ZM18 11H17.5C17.5 11.2761 17.7239 11.5 18 11.5V11ZM8 16.5H16V15.5H8V16.5ZM19.5 20V22H20.5V20H19.5ZM4.5 22V20H3.5V22H4.5ZM16 16.5C17.933 16.5 19.5 18.067 19.5 20H20.5C20.5 17.5147 18.4853 15.5 16 15.5V16.5ZM8 15.5C5.51472 15.5 3.5 17.5147 3.5 20H4.5C4.5 18.067 6.067 16.5 8 16.5V15.5ZM15.5 8C15.5 9.933 13.933 11.5 12 11.5V12.5C14.4853 12.5 16.5 10.4853 16.5 8H15.5ZM12 11.5C10.067 11.5 8.5 9.933 8.5 8H7.5C7.5 10.4853 9.51472 12.5 12 12.5V11.5ZM8.5 8C8.5 6.067 10.067 4.5 12 4.5V3.5C9.51472 3.5 7.5 5.51472 7.5 8H8.5ZM12 4.5C13.933 4.5 15.5 6.067 15.5 8H16.5C16.5 5.51472 14.4853 3.5 12 3.5V4.5ZM6.5 8C6.5 4.96243 8.96243 2.5 12 2.5V1.5C8.41015 1.5 5.5 4.41015 5.5 8H6.5ZM12 2.5C15.0376 2.5 17.5 4.96243 17.5 8H18.5C18.5 4.41015 15.5899 1.5 12 1.5V2.5ZM13.0068 10.0822C13.2941 11.8059 14.4748 12.7211 15.7541 12.8716C16.9943 13.0175 18.3396 12.4389 18.9472 11.2236L18.0528 10.7764C17.6604 11.5611 16.7557 11.9825 15.8709 11.8784C15.0252 11.7789 14.2059 11.1941 13.9932 9.9178L13.0068 10.0822ZM13.9286 9.21429C13.9286 9.60878 13.6088 9.92857 13.2143 9.92857V10.9286C14.1611 10.9286 14.9286 10.1611 14.9286 9.21429H13.9286ZM13.2143 9.92857C12.8198 9.92857 12.5 9.60878 12.5 9.21429H11.5C11.5 10.1611 12.2675 10.9286 13.2143 10.9286V9.92857ZM12.5 9.21429C12.5 8.8198 12.8198 8.5 13.2143 8.5V7.5C12.2675 7.5 11.5 8.26751 11.5 9.21429H12.5ZM13.2143 8.5C13.6088 8.5 13.9286 8.8198 13.9286 9.21429H14.9286C14.9286 8.26751 14.1611 7.5 13.2143 7.5V8.5ZM4 8.5H6V7.5H4V8.5ZM5.5 8V11H6.5V8H5.5ZM6 10.5H4V11.5H6V10.5ZM4.5 11V8H3.5V11H4.5ZM18 8.5H20V7.5H18V8.5ZM19.5 8V11H20.5V8H19.5ZM20 10.5H18V11.5H20V10.5ZM18.5 11V8H17.5V11H18.5Z'
    ],
    customStyles: {
        fill: 'currentColor'
    },
    pathAttrs: {
        transform: 'translate(-3.5, -1.5)'
    }
};
const facDots = {
    prefix: 'fac',
    iconName: 'dots',
    icon: [
        11,
        2,
        [],
        '',
        'M1.5 1.5C1.77614 1.5 2 1.27614 2 1C2 0.723858 1.77614 0.5 1.5 0.5C1.22386 0.5 1 0.723858 1 1C1 1.27614 1.22386 1.5 1.5 1.5 M10.5 1.5C10.7761 1.5 11 1.27614 11 1C11 0.723858 10.7761 0.5 10.5 0.5C10.2239 0.5 10 0.723858 10 1C10 1.27614 10.2239 1.5 10.5 1.5 M6 1.5C6.27614 1.5 6.5 1.27614 6.5 1C6.5 0.723858 6.27614 0.5 6 0.5C5.72386 0.5 5.5 0.723858 5.5 1C5.5 1.27614 5.72386 1.5 6 1.5Z'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    },
    pathAttrs: {
        transform: 'translate(-0.5, 0)'
    }
};
const facBarChart = {
    prefix: 'fac',
    iconName: 'barChart',
    icon: [
        13.000200271606445,
        13,
        [],
        '',
        'M4.66667 9.33325H2V13.9999H4.66667V9.33325Z M9.33317 5.33325H6.6665V13.9999H9.33317V5.33325Z M14.0002 2H11.3335V14H14.0002V2Z'
    ],
    customStyles: {
        fill: 'none',
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    },
    pathAttrs: {
        transform: 'translate(-1.5, -1.5)'
    }
};
const facGoto = {
    prefix: 'fac',
    iconName: 'goto',
    icon: [
        24,
        24,
        [],
        '',
        'M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M15 3H21M21 3V9M21 3L14 10'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facMail = {
    prefix: 'fac',
    iconName: 'mail',
    icon: [
        16,
        16,
        [],
        '',
        'M14.6668 3.99984C14.6668 3.2665 14.0668 2.6665 13.3335 2.6665H2.66683C1.9335 2.6665 1.3335 3.2665 1.3335 3.99984M14.6668 3.99984V11.9998C14.6668 12.7332 14.0668 13.3332 13.3335 13.3332H2.66683C1.9335 13.3332 1.3335 12.7332 1.3335 11.9998V3.99984M14.6668 3.99984L8.00016 8.6665L1.3335 3.99984'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facPhone = {
    prefix: 'fac',
    iconName: 'phone',
    icon: [
        16,
        16,
        [],
        '',
        'M14.6665 11.2802V13.2802C14.6672 13.4659 14.6292 13.6497 14.5548 13.8198C14.4804 13.9899 14.3713 14.1426 14.2345 14.2681C14.0977 14.3937 13.9362 14.4892 13.7603 14.5487C13.5844 14.6082 13.398 14.6303 13.2131 14.6136C11.1617 14.3907 9.19113 13.6897 7.45979 12.5669C5.84901 11.5433 4.48335 10.1777 3.45979 8.56689C2.33311 6.8277 1.63195 4.84756 1.41313 2.78689C1.39647 2.60254 1.41838 2.41673 1.47746 2.24131C1.53654 2.06589 1.63151 1.90469 1.7563 1.76797C1.8811 1.63126 2.033 1.52203 2.20232 1.44724C2.37164 1.37245 2.55469 1.33374 2.73979 1.33356H4.73979C5.06333 1.33038 5.37699 1.44495 5.6223 1.65592C5.86761 1.86689 6.02784 2.15986 6.07313 2.48023C6.15754 3.12027 6.31409 3.74871 6.53979 4.35356C6.62949 4.59218 6.6489 4.8515 6.59573 5.10081C6.54256 5.35012 6.41903 5.57897 6.23979 5.76023L5.39313 6.60689C6.34216 8.27592 7.7241 9.65786 9.39313 10.6069L10.2398 9.76023C10.4211 9.58098 10.6499 9.45746 10.8992 9.40429C11.1485 9.35112 11.4078 9.37053 11.6465 9.46023C12.2513 9.68593 12.8797 9.84248 13.5198 9.92689C13.8436 9.97258 14.1394 10.1357 14.3508 10.3852C14.5622 10.6347 14.6746 10.9533 14.6665 11.2802Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSortDesc = {
    prefix: 'fac',
    iconName: 'sortDesc',
    icon: [24, 24, [], '', 'M3 12H15M3 6H21M3 18H9'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSortAsc = {
    prefix: 'fac',
    iconName: 'sortAsc',
    icon: [24, 24, [], '', 'M3 12H15M3 6H9M3 18H21'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facCheckAll = {
    prefix: 'fac',
    iconName: 'checkAll',
    icon: [24, 24, [], '', 'M2 12L7 17L8 16M18 6L11 13M23 6L12 17L7 12'],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facGithub = {
    prefix: 'fac',
    iconName: 'github',
    icon: [
        15,
        14,
        [],
        '',
        'M10.3054 12.9823V11.9788C10.3054 11.5312 10.1655 11.0383 9.94248 10.6136C9.88903 10.5118 9.82891 10.4104 9.76226 10.3118C10.521 10.1175 11.1438 9.79972 11.6156 9.36327C12.2899 8.73942 12.6102 7.91453 12.6102 6.99873C12.6102 6.26707 12.3478 5.56695 11.8989 4.98108C11.9684 4.70028 12.0274 4.35632 12.0419 4.01702C12.0517 3.78751 12.0419 3.5422 11.992 3.31174C11.943 3.08519 11.8464 2.83314 11.6515 2.63529L11.5046 2.48616H11.2953C10.3369 2.48616 9.67294 2.96286 9.33115 3.28011C8.85236 3.14533 8.34291 3.06666 7.79443 3.06666C7.26064 3.06666 6.74139 3.1453 6.2579 3.28044C5.91664 2.96362 5.25278 2.48616 4.29354 2.48616H4.08441L3.93756 2.63505C3.74061 2.83473 3.64074 3.08626 3.58965 3.3166C3.53806 3.54919 3.52834 3.79502 3.53813 4.02365C3.55268 4.36359 3.61233 4.7047 3.67673 4.97898C3.22937 5.56581 2.94384 6.2535 2.94384 6.99873C2.94384 7.9174 3.27042 8.74154 3.94982 9.3682C4.42832 9.80956 5.06081 10.134 5.83177 10.3374C5.75051 10.4562 5.67795 10.5809 5.61446 10.7084C5.37998 10.7315 5.14921 10.7401 4.98628 10.7401C4.739 10.7401 4.68395 10.7154 4.66825 10.7071C4.64923 10.6972 4.6085 10.6703 4.46748 10.4824L4.46725 10.4821C4.15371 10.0649 3.77718 9.72757 3.27077 9.58091L3.22477 9.56759L3.17708 9.56324C2.98011 9.54529 2.69039 9.59577 2.51287 9.83993C2.41184 9.97888 2.36834 10.1615 2.41603 10.3468C2.45969 10.5165 2.56565 10.6364 2.66085 10.7136L2.67356 10.7239L2.68692 10.7334C2.86456 10.8592 2.96897 11.0262 3.05869 11.2466C3.09567 11.3374 3.1259 11.4259 3.16013 11.5261C3.16992 11.5547 3.18004 11.5843 3.19075 11.6152C3.2344 11.7413 3.28849 11.8909 3.36297 12.0321C3.38866 12.0836 3.41686 12.1326 3.44733 12.1793C1.9954 10.9836 1.06665 9.16273 1.06665 7.10596C1.06665 3.48578 3.95249 0.566895 7.49998 0.566895C11.0475 0.566895 13.9333 3.48578 13.9333 7.10596C13.9333 9.70354 12.4497 11.9324 10.3054 12.9823ZM5.26695 12.9023V13.2352C4.97566 13.125 4.69427 12.9942 4.42455 12.8447C4.58125 12.8835 4.74212 12.9023 4.90013 12.9023H5.26695Z'
    ],
    customStyles: {
        fill: 'white'
    }
};
const facAttachment = {
    prefix: 'fac',
    iconName: 'attachment',
    icon: [
        16,
        16,
        [],
        '',
        'M14.2929 7.36678L8.16621 13.4934C7.41565 14.244 6.39767 14.6657 5.33621 14.6657C4.27475 14.6657 3.25677 14.244 2.50621 13.4934C1.75565 12.7429 1.33398 11.7249 1.33398 10.6634C1.33398 9.60199 1.75565 8.584 2.50621 7.83344L8.63288 1.70678C9.13325 1.2064 9.81191 0.925293 10.5195 0.925293C11.2272 0.925293 11.9058 1.2064 12.4062 1.70678C12.9066 2.20715 13.1877 2.8858 13.1877 3.59344C13.1877 4.30108 12.9066 4.97973 12.4062 5.48011L6.27288 11.6068C6.02269 11.857 5.68336 11.9975 5.32954 11.9975C4.97572 11.9975 4.6364 11.857 4.38621 11.6068C4.13602 11.3566 3.99547 11.0173 3.99547 10.6634C3.99547 10.3096 4.13602 9.9703 4.38621 9.72011L10.0462 4.06678'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facSimpleCalendar = {
    prefix: 'fac',
    iconName: 'simpleCalendar',
    icon: [
        24,
        24,
        [],
        '',
        'M15 3V7M9 3V7M4 11H20M20 11V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5H18C19.1046 5 20 5.89543 20 7V11Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facHomeCheck = {
    prefix: 'fac',
    iconName: 'homeCheck',
    icon: [
        17,
        18,
        [],
        '',
        'M10.3045 2.84359L8 1L1 6.6V15.4C1 15.8243 1.16389 16.2313 1.45561 16.5314C1.74733 16.8314 2.143 17 2.55556 17H13.4444C13.857 17 14.2527 16.8314 14.5444 16.5314C14.8361 16.2313 15 15.8243 15 15.4V10.5M9 7L11 9L16 4'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facInbox = {
    prefix: 'fac',
    iconName: 'inbox',
    icon: [
        24,
        24,
        [],
        '',
        'M22 12H16L14 15H10L8 12H2M22 12V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V12M22 12L18.55 5.11C18.3844 4.77679 18.1292 4.49637 17.813 4.30028C17.4967 4.10419 17.1321 4.0002 16.76 4H7.24C6.86792 4.0002 6.50326 4.10419 6.18704 4.30028C5.87083 4.49637 5.61558 4.77679 5.45 5.11L2 12'
    ],
    customStyles: {
        stroke: 'currentColor',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        fill: 'none'
    }
};
const facWarning = {
    prefix: 'fac',
    iconName: 'warning',
    icon: [
        40,
        40,
        [],
        '',
        'M3.03294 30L17.1496 6.43331C17.4467 5.94349 17.8651 5.53851 18.3643 5.25745C18.8635 4.97639 19.4267 4.82874 19.9996 4.82874C20.5725 4.82874 21.1357 4.97639 21.6349 5.25745C22.1341 5.53851 22.5525 5.94349 22.8496 6.43331L36.9663 30C37.2573 30.504 37.4113 31.0755 37.413 31.6575C37.4146 32.2395 37.2638 32.8119 36.9756 33.3175C36.6873 33.8232 36.2717 34.2446 35.7701 34.5397C35.2685 34.8349 34.6983 34.9936 34.1163 35H5.88294C5.30094 34.9936 4.73076 34.8349 4.22912 34.5397C3.72748 34.2446 3.31188 33.8232 3.02365 33.3175C2.73543 32.8119 2.58463 32.2395 2.58626 31.6575C2.58789 31.0755 2.74189 30.504 3.03294 30ZM21 15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15V21.6667C19 22.219 19.4477 22.6667 20 22.6667C20.5523 22.6667 21 22.219 21 21.6667V15ZM18.6667 27.5C18.6667 26.7636 19.2636 26.1666 20 26.1666C20.7364 26.1666 21.3334 26.7636 21.3334 27.5C21.3334 28.2363 20.7364 28.8333 20 28.8333C19.2636 28.8333 18.6667 28.2363 18.6667 27.5Z'
    ],
    customStyles: {
        stroke: 'none',
        fill: 'currentColor',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
    }
};
const facInfo = {
    prefix: 'fac',
    iconName: 'info',
    icon: [
        40,
        40,
        [],
        '',
        'M36.6667 20C36.6667 29.2048 29.2048 36.6667 20 36.6667C10.7953 36.6667 3.33334 29.2048 3.33334 20C3.33334 10.7953 10.7953 3.33337 20 3.33337C29.2048 3.33337 36.6667 10.7953 36.6667 20ZM18.6667 13.3333C18.6667 12.597 19.2636 12 20 12C20.7364 12 21.3333 12.597 21.3333 13.3333C21.3333 14.0697 20.7364 14.6667 20 14.6667C19.2636 14.6667 18.6667 14.0697 18.6667 13.3333ZM21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20V26.6667C19 27.219 19.4477 27.6667 20 27.6667C20.5523 27.6667 21 27.219 21 26.6667V20Z'
    ],
    customStyles: {
        stroke: 'none',
        fill: 'currentColor',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
    }
};
const facSuccess = {
    prefix: 'fac',
    iconName: 'success',
    icon: [
        40,
        40,
        [],
        '',
        'M36.6666 20C36.6666 29.2048 29.2047 36.6667 20 36.6667C10.7952 36.6667 3.33331 29.2048 3.33331 20C3.33331 10.7953 10.7952 3.33337 20 3.33337C29.2047 3.33337 36.6666 10.7953 36.6666 20ZM29.041 15.7065C29.4312 15.3157 29.4307 14.6825 29.0398 14.2923C28.649 13.9021 28.0158 13.9026 27.6256 14.2935L18.3327 23.6019L14.0404 19.3096C13.6499 18.919 13.0167 18.919 12.6262 19.3096C12.2357 19.7001 12.2357 20.3332 12.6262 20.7238L17.6262 25.7238C17.8138 25.9114 18.0684 26.0168 18.3337 26.0167C18.5991 26.0166 18.8535 25.911 19.041 25.7232L29.041 15.7065Z'
    ],
    customStyles: {
        stroke: 'none',
        fill: 'currentColor',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
    }
};
const facError = {
    prefix: 'fac',
    iconName: 'error',
    icon: [
        40,
        40,
        [],
        '',
        'M36.6666 20C36.6666 29.2048 29.2047 36.6667 20 36.6667C10.7952 36.6667 3.33331 29.2048 3.33331 20C3.33331 10.7953 10.7952 3.33337 20 3.33337C29.2047 3.33337 36.6666 10.7953 36.6666 20ZM25.7071 14.2929C26.0976 14.6834 26.0976 15.3166 25.7071 15.7071L21.4142 20L25.7071 24.2929C26.0976 24.6834 26.0976 25.3166 25.7071 25.7071C25.3166 26.0976 24.6834 26.0976 24.2929 25.7071L20 21.4142L15.7071 25.7071C15.3166 26.0976 14.6834 26.0976 14.2929 25.7071C13.9024 25.3166 13.9024 24.6834 14.2929 24.2929L18.5858 20L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L20 18.5858L24.2929 14.2929C24.6834 13.9024 25.3166 13.9024 25.7071 14.2929Z'
    ],
    customStyles: {
        stroke: 'none',
        fill: 'currentColor',
        'fill-rule': 'evenodd',
        'clip-rule': 'evenodd'
    }
};
const facPlusSquare = {
    prefix: 'fac',
    iconName: 'plusSquare',
    icon: [
        24,
        24,
        [],
        '',
        'M12 8V16M8 12H16M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facMinusSquare = {
    prefix: 'fac',
    iconName: 'minusSquare',
    icon: [
        24,
        24,
        [],
        '',
        'M8 12H16M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facDragHandle = {
    prefix: 'fac',
    iconName: 'dragHandle',
    icon: [
        8,
        12,
        [],
        '',
        'M1.99999 6.66699C2.36818 6.66699 2.66666 6.36852 2.66666 6.00033C2.66666 5.63214 2.36818 5.33366 1.99999 5.33366C1.63181 5.33366 1.33333 5.63214 1.33333 6.00033C1.33333 6.36852 1.63181 6.66699 1.99999 6.66699Z M1.99999 2.00033C2.36818 2.00033 2.66666 1.70185 2.66666 1.33366C2.66666 0.965469 2.36818 0.666992 1.99999 0.666992C1.63181 0.666992 1.33333 0.965469 1.33333 1.33366C1.33333 1.70185 1.63181 2.00033 1.99999 2.00033Z M1.99999 11.3337C2.36818 11.3337 2.66666 11.0352 2.66666 10.667C2.66666 10.2988 2.36818 10.0003 1.99999 10.0003C1.63181 10.0003 1.33333 10.2988 1.33333 10.667C1.33333 11.0352 1.63181 11.3337 1.99999 11.3337Z M6 6.66699C6.36819 6.66699 6.66666 6.36852 6.66666 6.00033C6.66666 5.63214 6.36819 5.33366 6 5.33366C5.63181 5.33366 5.33333 5.63214 5.33333 6.00033C5.33333 6.36852 5.63181 6.66699 6 6.66699Z M6 2.00033C6.36819 2.00033 6.66666 1.70185 6.66666 1.33366C6.66666 0.965469 6.36819 0.666992 6 0.666992C5.63181 0.666992 5.33333 0.965469 5.33333 1.33366C5.33333 1.70185 5.63181 2.00033 6 2.00033Z M6 11.3337C6.36819 11.3337 6.66666 11.0352 6.66666 10.667C6.66666 10.2988 6.36819 10.0003 6 10.0003C5.63181 10.0003 5.33333 10.2988 5.33333 10.667C5.33333 11.0352 5.63181 11.3337 6 11.3337Z M1.99999 6.66699C2.36818 6.66699 2.66666 6.36852 2.66666 6.00033C2.66666 5.63214 2.36818 5.33366 1.99999 5.33366C1.63181 5.33366 1.33333 5.63214 1.33333 6.00033C1.33333 6.36852 1.63181 6.66699 1.99999 6.66699Z M1.99999 2.00033C2.36818 2.00033 2.66666 1.70185 2.66666 1.33366C2.66666 0.965469 2.36818 0.666992 1.99999 0.666992C1.63181 0.666992 1.33333 0.965469 1.33333 1.33366C1.33333 1.70185 1.63181 2.00033 1.99999 2.00033Z M1.99999 11.3337C2.36818 11.3337 2.66666 11.0352 2.66666 10.667C2.66666 10.2988 2.36818 10.0003 1.99999 10.0003C1.63181 10.0003 1.33333 10.2988 1.33333 10.667C1.33333 11.0352 1.63181 11.3337 1.99999 11.3337Z M6 6.66699C6.36819 6.66699 6.66666 6.36852 6.66666 6.00033C6.66666 5.63214 6.36819 5.33366 6 5.33366C5.63181 5.33366 5.33333 5.63214 5.33333 6.00033C5.33333 6.36852 5.63181 6.66699 6 6.66699Z M6 2.00033C6.36819 2.00033 6.66666 1.70185 6.66666 1.33366C6.66666 0.965469 6.36819 0.666992 6 0.666992C5.63181 0.666992 5.33333 0.965469 5.33333 1.33366C5.33333 1.70185 5.63181 2.00033 6 2.00033Z M6 11.3337C6.36819 11.3337 6.66666 11.0352 6.66666 10.667C6.66666 10.2988 6.36819 10.0003 6 10.0003C5.63181 10.0003 5.33333 10.2988 5.33333 10.667C5.33333 11.0352 5.63181 11.3337 6 11.3337Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facGrid2 = {
    prefix: 'fac',
    iconName: 'grid2',
    icon: [
        16,
        16,
        [],
        '',
        'M4.667 2H2v2.667h2.667V2ZM9.333 2H6.667v2.667h2.666V2ZM14 2h-2.667v2.667H14V2ZM9.333 6.667H6.667v2.666h2.666V6.667ZM14 6.667h-2.667v2.666H14V6.667ZM9.333 11.333H6.667V14h2.666v-2.667ZM14 11.333h-2.667V14H14v-2.667ZM4.667 6.667H2v2.666h2.667V6.667ZM4.667 11.333H2V14h2.667v-2.667Z'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facRefreshRight = {
    prefix: 'fac',
    iconName: 'refreshRight',
    icon: [
        24,
        24,
        [],
        '',
        'M23 4.00001V10M23 10H17M23 10L18.36 5.64001C17.2853 4.56473 15.9556 3.77922 14.4952 3.35679C13.0348 2.93436 11.4911 2.88877 10.0083 3.22427C8.52547 3.55978 7.1518 4.26545 6.01547 5.27543C4.87913 6.28542 4.01717 7.5668 3.51 9.00001M1 20V14M1 14H7M1 14L5.64 18.36C6.71475 19.4353 8.04437 20.2208 9.50481 20.6432C10.9652 21.0657 12.5089 21.1113 13.9917 20.7758C15.4745 20.4402 16.8482 19.7346 17.9845 18.7246C19.1209 17.7146 19.9828 16.4332 20.49 15'
    ],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facMinus = {
    prefix: 'fac',
    iconName: 'minus',
    icon: [24, 24, [], '', 'M5 12H19'],
    customStyles: {
        stroke: 'currentColor',
        fill: 'none',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round'
    }
};
const facThreeDots = 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z M7.5 12.5C7.77614 12.5 8 12.2761 8 12C8 11.7239 7.77614 11.5 7.5 11.5C7.22386 11.5 7 11.7239 7 12C7 12.2761 7.22386 12.5 7.5 12.5Z M16.5 12.5C16.7761 12.5 17 12.2761 17 12C17 11.7239 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.7239 16 12C16 12.2761 16.2239 12.5 16.5 12.5Z M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z';
const facSubMenu = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M1.5 6H6.5M1.5 3H10.5M1.5 9H10.5" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const facHorizontalGrid = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M10.5 1.5H1.5V5H10.5V1.5Z" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<path d="M10.5 7H1.5V10.5H10.5V7Z" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';
const filter = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M11 1.5H1L5 6.23V9.5L7 10.5V6.23L11 1.5Z" stroke="#868484" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</svg>';

var customIcons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    facDownload: facDownload,
    facUpload: facUpload,
    facEdit: facEdit,
    facTrash: facTrash,
    facUndo: facUndo,
    facRedo: facRedo,
    facAddUsers: facAddUsers,
    facOrganization: facOrganization,
    facLink: facLink,
    facClone: facClone,
    facPlusRegular: facPlusRegular,
    facOpenFolderO: facOpenFolderO,
    facKeyBold: facKeyBold,
    facfilledExclamatory: facfilledExclamatory,
    facSitemapO: facSitemapO,
    facOpenLog: facOpenLog,
    facClock: facClock,
    clock: clock,
    facArrowDownRegular: facArrowDownRegular,
    facArrowUpRegular: facArrowUpRegular,
    facArrowLeftRegular: facArrowLeftRegular,
    facArrowRightRegular: facArrowRightRegular,
    facAddNewPipeline: facAddNewPipeline,
    facDelete: facDelete,
    facExternalLink: facExternalLink,
    facCog: facCog,
    cogsIcon: cogsIcon,
    starIcon: starIcon,
    grid2HorizontalIcon: grid2HorizontalIcon,
    gridIcon: gridIcon,
    facGear: facGear,
    facSearch: facSearch,
    facExclamation: facExclamation,
    facArrowDownInCircle: facArrowDownInCircle,
    facArrowLeftInCircle: facArrowLeftInCircle,
    facArrowRightInCircle: facArrowRightInCircle,
    facArrowUpInCircle: facArrowUpInCircle,
    facExclamationCircle: facExclamationCircle,
    facBuildFailure: facBuildFailure,
    failIcon: failIcon,
    facBuildSuccess: facBuildSuccess,
    facPending: facPending,
    facStart: facStart,
    facResume: facResume,
    facPortfolio: facPortfolio,
    facStop: facStop,
    facLogs: facLogs,
    facChevronUp: facChevronUp,
    facChevronDown: facChevronDown,
    facChevronRight: facChevronRight,
    facChevronLeft: facChevronLeft,
    facScrollerLeft: facScrollerLeft,
    facScrollerRight: facScrollerRight,
    facTimes: facTimes,
    facBars: facBars,
    facEyeOpen: facEyeOpen,
    facEyeOff: facEyeOff,
    facLock: facLock,
    facExclamationTriangle: facExclamationTriangle,
    facExclamationTriangleSVG: facExclamationTriangleSVG,
    facCheck: facCheck,
    facPlusCircle: facPlusCircle,
    facMinusCircle: facMinusCircle,
    facCheckBroken: facCheckBroken,
    warning: warning,
    facEditorExecution: facEditorExecution,
    fullStarBlue: fullStarBlue,
    fullStarBlueBigger: fullStarBlueBigger,
    emptyStar: emptyStar,
    emptyStarBigger: emptyStarBigger,
    facReject: facReject,
    facSimpleCheck: facSimpleCheck,
    facOpen: facOpen,
    boldBell: boldBell,
    ellipsis: ellipsis,
    leftBottomArrow: leftBottomArrow,
    leftTopArrow: leftTopArrow,
    rightBottomArrow: rightBottomArrow,
    rightTopArrow: rightTopArrow,
    facAlert: facAlert,
    facApproveCheckMark: facApproveCheckMark,
    facCalendar: facCalendar,
    timeDetails: timeDetails,
    puzzleIcon: puzzleIcon,
    facSnail: facSnail,
    wrench: wrench,
    cubeIcon: cubeIcon,
    testPack: testPack,
    facDoubleArrowDown: facDoubleArrowDown,
    facMenuEdit: facMenuEdit,
    facEmailNotification: facEmailNotification,
    facCustomNotification: facCustomNotification,
    video: video,
    videoDisabled: videoDisabled,
    rotationLeft: rotationLeft,
    rotationRight: rotationRight,
    halfRotationLeft: halfRotationLeft,
    rotationLeftDot: rotationLeftDot,
    sortingDown: sortingDown,
    sortingUp: sortingUp,
    mail: mail,
    facArrowForward: facArrowForward,
    facArrowBack: facArrowBack,
    facQuestionInCircle: facQuestionInCircle,
    facExpand: facExpand,
    facCompress: facCompress,
    facStartPlay: facStartPlay,
    breakPlay: breakPlay,
    pausePlay: pausePlay,
    backwardPlay: backwardPlay,
    forwardPlay: forwardPlay,
    facResumePlay: facResumePlay,
    fileIcon: fileIcon,
    facSorting: facSorting,
    facInfoCircle: facInfoCircle,
    FacHelpIcon: FacHelpIcon,
    facDots: facDots,
    facBarChart: facBarChart,
    facGoto: facGoto,
    facMail: facMail,
    facPhone: facPhone,
    facSortDesc: facSortDesc,
    facSortAsc: facSortAsc,
    facCheckAll: facCheckAll,
    facGithub: facGithub,
    facAttachment: facAttachment,
    facSimpleCalendar: facSimpleCalendar,
    facHomeCheck: facHomeCheck,
    facInbox: facInbox,
    facWarning: facWarning,
    facInfo: facInfo,
    facSuccess: facSuccess,
    facError: facError,
    facPlusSquare: facPlusSquare,
    facMinusSquare: facMinusSquare,
    facDragHandle: facDragHandle,
    facGrid2: facGrid2,
    facRefreshRight: facRefreshRight,
    facMinus: facMinus,
    facThreeDots: facThreeDots,
    facSubMenu: facSubMenu,
    facHorizontalGrid: facHorizontalGrid,
    filter: filter
});

const CUSTOM_ICONS = Object.values(customIcons).filter((icon) => !!icon.prefix);
CUSTOM_ICONS.forEach((icon) => (icon.prefix = 'far'));

config.autoAddCss = false;
class FaCustomIconDirective {
    constructor(faIconComponent, faLibrary, faConfig, cdRef) {
        this.faIconComponent = faIconComponent;
        this.faLibrary = faLibrary;
        this.faConfig = faConfig;
        this.cdRef = cdRef;
        const originalRenderIcon = this.faIconComponent.renderIcon;
        const comp = this;
        this.faIconComponent.renderIcon = function (definition, params) {
            const args = arguments;
            Promise.resolve().then(() => {
                if (comp.customStyles) {
                    Object.assign(params.styles, comp.customStyles);
                    const renderedIcon = icon(definition, params);
                    const html = renderedIcon.abstract.map(elem => {
                        (elem.children || []).forEach(child => {
                            if ('fill' in child.attributes) {
                                delete child.attributes.fill;
                            }
                            if (child.tag === 'path' && comp.pathAttrs) {
                                child.attributes = Object.assign(Object.assign({}, child.attributes), comp.pathAttrs);
                            }
                        });
                        return toHtml(elem);
                    });
                    this.renderedIconHTML = this.sanitizer.bypassSecurityTrustHtml(html.join('\n'));
                }
                else {
                    originalRenderIcon.apply(this, args);
                }
                comp.cdRef.markForCheck();
            });
        };
    }
    ngOnChanges() {
        if (typeof this.icon === 'string') {
            const iconDef = this.faLibrary.getIconDefinition(this.faConfig.defaultPrefix, this.icon);
            this.customStyles = iconDef.customStyles;
            this.pathAttrs = iconDef.pathAttrs;
        }
        else if (this.icon && this.icon.customStyles) {
            this.customStyles = this.icon.customStyles;
            this.pathAttrs = this.icon.pathAttrs;
        }
    }
}
FaCustomIconDirective.ɵfac = function FaCustomIconDirective_Factory(t) { return new (t || FaCustomIconDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FaIconComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FaIconLibrary), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FaConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
FaCustomIconDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FaCustomIconDirective, selectors: [["fa-icon"]], inputs: { icon: "icon" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
FaCustomIconDirective.ctorParameters = () => [
    { type: FaIconComponent },
    { type: FaIconLibrary },
    { type: FaConfig },
    { type: ChangeDetectorRef }
];
FaCustomIconDirective.propDecorators = {
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FaCustomIconDirective, [{
        type: Directive,
        args: [{
                selector: 'fa-icon'
            }]
    }], function () { return [{ type: ɵngcc1.FaIconComponent }, { type: ɵngcc1.FaIconLibrary }, { type: ɵngcc1.FaConfig }, { type: ɵngcc0.ChangeDetectorRef }]; }, { icon: [{
            type: Input
        }] }); })();

class IconsModule {
    constructor(faConfig, iconLibrary) {
        faConfig.defaultPrefix = 'far';
        iconLibrary.addIcons(...CUSTOM_ICONS);
    }
}
IconsModule.ɵfac = function IconsModule_Factory(t) { return new (t || IconsModule)(ɵngcc0.ɵɵinject(ɵngcc1.FaConfig), ɵngcc0.ɵɵinject(ɵngcc1.FaIconLibrary)); };
IconsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: IconsModule });
IconsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [FontAwesomeModule, FontAwesomeModule] });
IconsModule.ctorParameters = () => [
    { type: FaConfig },
    { type: FaIconLibrary }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconsModule, [{
        type: NgModule,
        args: [{
                declarations: [FaCustomIconDirective],
                imports: [FontAwesomeModule],
                exports: [FontAwesomeModule, FaCustomIconDirective]
            }]
    }], function () { return [{ type: ɵngcc1.FaConfig }, { type: ɵngcc1.FaIconLibrary }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IconsModule, { declarations: function () { return [FaCustomIconDirective]; }, imports: function () { return [FontAwesomeModule]; }, exports: function () { return [FontAwesomeModule, FaCustomIconDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CUSTOM_ICONS, FaCustomIconDirective, FacHelpIcon, IconsModule, backwardPlay, boldBell, breakPlay, clock, cogsIcon, cubeIcon, ellipsis, emptyStar, emptyStarBigger, facAddNewPipeline, facAddUsers, facAlert, facApproveCheckMark, facArrowBack, facArrowDownInCircle, facArrowDownRegular, facArrowForward, facArrowLeftInCircle, facArrowLeftRegular, facArrowRightInCircle, facArrowRightRegular, facArrowUpInCircle, facArrowUpRegular, facAttachment, facBarChart, facBars, facBuildFailure, facBuildSuccess, facCalendar, facCheck, facCheckAll, facCheckBroken, facChevronDown, facChevronLeft, facChevronRight, facChevronUp, facClock, facClone, facCog, facCompress, facCustomNotification, facDelete, facDots, facDoubleArrowDown, facDownload, facDragHandle, facEdit, facEditorExecution, facEmailNotification, facError, facExclamation, facExclamationCircle, facExclamationTriangle, facExclamationTriangleSVG, facExpand, facExternalLink, facEyeOff, facEyeOpen, facGear, facGithub, facGoto, facGrid2, facHomeCheck, facHorizontalGrid, facInbox, facInfo, facInfoCircle, facKeyBold, facLink, facLock, facLogs, facMail, facMenuEdit, facMinus, facMinusCircle, facMinusSquare, facOpen, facOpenFolderO, facOpenLog, facOrganization, facPending, facPhone, facPlusCircle, facPlusRegular, facPlusSquare, facPortfolio, facQuestionInCircle, facRedo, facRefreshRight, facReject, facResume, facResumePlay, facScrollerLeft, facScrollerRight, facSearch, facSimpleCalendar, facSimpleCheck, facSitemapO, facSnail, facSortAsc, facSortDesc, facSorting, facStart, facStartPlay, facStop, facSubMenu, facSuccess, facThreeDots, facTimes, facTrash, facUndo, facUpload, facWarning, facfilledExclamatory, failIcon, fileIcon, filter, forwardPlay, fullStarBlue, fullStarBlueBigger, grid2HorizontalIcon, gridIcon, halfRotationLeft, leftBottomArrow, leftTopArrow, mail, pausePlay, puzzleIcon, rightBottomArrow, rightTopArrow, rotationLeft, rotationLeftDot, rotationRight, sortingDown, sortingUp, starIcon, testPack, timeDetails, video, videoDisabled, warning, wrench };

